'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var polished = require('polished');
var React = require('react');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var reactRouterDom = require('react-router-dom');
var ProgressBar$1 = require('@ramonak/react-progress-bar');
var reactHelmet = require('react-helmet');
var Switch = require('react-switch');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ProgressBar__default = /*#__PURE__*/_interopDefaultLegacy(ProgressBar$1);
var Switch__default = /*#__PURE__*/_interopDefaultLegacy(Switch);

var Alert = styled__default["default"].div.withConfig({
  displayName: "Alert",
  componentId: "sc-1slo1sy-0"
})(["background:", ";padding:15px 25px;border-radius:", ";margin:10px 0;font-family:", ";font-size:1rem;font-weight:bold;color:", ";"], function (props) {
  if (props.type === 'info') return props.theme.colors.active;
  if (props.type === 'success') return props.theme.colors.success;
  if (props.type === 'warning') return props.theme.colors.warning;
  if (props.type === 'error') return props.theme.colors.danger;
  return '#E0E6EE';
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return polished.transparentize(0.1, '#FFFFFF');
});

var Article = styled__default["default"].div.withConfig({
  displayName: "Article",
  componentId: "sc-1shjiio-0"
})(["background:white;padding:10px 25px;border-radius:5px;margin:20px 0;"]);

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var AvatarWrapper = styled__default["default"].div.withConfig({
  displayName: "Avatar__AvatarWrapper",
  componentId: "sc-m2vzoo-0"
})(["background:", ";color:", ";cursor:pointer;font-family:", ";border:2px solid transparent;border-radius:", ";position:relative;width:50px;height:50px;display:inline-block;margin:5px;white-space:nowrap;transition:background .1s ease-in,box-shadow .1s ease-out,width .1s ease-in;&:hover{background:", "}&:focus,&:active{background:", "}", " ", " ", " ", " .AvatarInner{margin:0 auto;text-align:center;overflow:hidden;}overflow:hidden;vertical-align:top;img{width:100%;max-height:66px;}"], function (props) {
  if (props.color) return props.color;
  if (props.dark) return props.theme.colors.primaryDarker;
  return props.theme.colors.bgBtnDefault;
}, function (props) {
  if (props.color) return 'white';
  if (props.dark) return props.theme.colors.grayLight;
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  if (props.round) return '50%';
  return props.theme.borderRadius;
}, function (props) {
  if (props.color) return polished.darken(0.2, props.color);
  if (props.dark) return polished.darken(0.1, props.theme.colors.primaryDarker);
  return polished.darken(0.05, props.theme.colors.bgBtnDefault);
}, function (props) {
  if (props.color) return polished.darken(0.3, props.color);
  if (props.dark) return polished.darken(0.7, props.theme.colors.primaryDarker);
  return polished.darken(0.1, props.theme.colors.bgBtnDefault);
}, function (props) {
  return props.size === 'xs' && styled.css(["width:20px;height:20px;font-size:11px;line-height:16px;"]);
}, function (props) {
  return props.size === 'sm' && styled.css(["width:30px;height:30px;line-height:26px;"]);
}, function (props) {
  return props.size === 'md' && styled.css(["width:50px;height:50px;font-size:18px;line-height:46px;"]);
}, function (props) {
  return props.size === 'lg' && styled.css(["width:70px;height:70px;font-size:24px;line-height:66px;"]);
});

var Avatar = function Avatar(_ref) {
  var style = _ref.style,
      size = _ref.size,
      icon = _ref.icon,
      round = _ref.round,
      name = _ref.name,
      colored = _ref.colored,
      image = _ref.image,
      abbreviate = _ref.abbreviate,
      dark = _ref.dark;

  var abbr = function abbr(text) {
    var namesArray = text.split(' ');
    if (namesArray.length === 1) return "".concat(namesArray[0].charAt(0));else return "".concat(namesArray[0].charAt(0)).concat(namesArray[namesArray.length - 1].charAt(0));
  };

  var toColor = function toColor(text) {
    var colors = ['#FFB800', '#3A8AE8', '#FF6660', '#FB2162', '#FB6660', '#20BDA1', '#0C4056', '#527D4D', '#283D26', '#7CBD75', '#87CC7F', '#6BA365', '#537BC9', '#57A2D4', '#57AFBD', '#57D4C2', '#53C997'];
    var hash = 0;
    if (text.length === 0) return hash;

    for (var i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }

    hash = (hash % colors.length + colors.length) % colors.length;
    return colors[hash];
  };

  var color = colored ? toColor(name) : '';

  if (name && !icon) {
    if (abbreviate) {
      name = abbr(name);
    }

    icon = /*#__PURE__*/React__namespace.createElement("span", {
      className: "username"
    }, name);
  }

  if (image) {
    icon = /*#__PURE__*/React__namespace.createElement("img", {
      src: image,
      alt: name,
      crossOrigin: "anonymous"
    });
  }

  if (!icon) {
    icon = /*#__PURE__*/React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      icon: freeRegularSvgIcons.faUser,
      fixedWidth: true
    });
  }

  return /*#__PURE__*/React__namespace.createElement(AvatarWrapper, {
    style: style,
    size: size,
    round: round,
    color: color,
    dark: dark
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "AvatarInner"
  }, icon));
};

Avatar.propTypes = {
  abbreviate: PropTypes.bool,
  colored: PropTypes.bool,
  dark: PropTypes.bool,
  icon: PropTypes.node,
  image: PropTypes.string,
  name: PropTypes.string,
  round: PropTypes.bool,
  size: PropTypes.string,
  style: PropTypes.object
};
Avatar.defaultProps = {
  size: 'sm',
  round: false,
  name: ''
};

function BaseBadge(_ref) {
  var content = _ref.content,
      small = _ref.small,
      className = _ref.className,
      active = _ref.active,
      danger = _ref.danger,
      primary = _ref.primary,
      block = _ref.block,
      children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: className
  }, children, /*#__PURE__*/React__namespace.createElement(Dot, {
    small: small,
    active: active,
    danger: danger,
    primary: primary,
    block: block
  }, !small ? content : ''));
}

var Badge = styled__default["default"](BaseBadge).withConfig({
  displayName: "Badge",
  componentId: "sc-9m624i-0"
})(["", " ", ""], function (props) {
  return !props.children && styled.css(["display:inline-block;position:absolute;right:5px;"]);
}, function (props) {
  return props.block && styled.css(["right:0;position:relative;text-align:right;display:inline-block;span{position:relative;top:-1px;}"]);
});
var Dot = styled__default["default"].span.withConfig({
  displayName: "Badge__Dot",
  componentId: "sc-9m624i-1"
})(["background:", ";color:", ";font-family:", ";font-size:10px;text-align:center;text-shadow:none;padding:0px 5px;position:absolute;right:5px;display:inline-block;border-radius:10px;height:20px;line-height:20px;min-width:20px;", " ", ""], function (props) {
  if (props.active) return props.theme.colors.active;
  if (props.primary) return props.theme.colors.primary;
  if (props.danger) return props.theme.colors.danger;
  return '#F9F9F9';
}, function (props) {
  if (props.active) return 'white';
  if (props.primary) return 'white';
  if (props.danger) return 'white';
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.small && styled.css(["padding:0px 4px;border-radius:4px;height:8px;line-height:8px;min-width:8px;"]);
}, function (props) {
  return props.block && styled.css(["right:0;position:relative;"]);
});

var Box = styled__default["default"].div.withConfig({
  displayName: "Box",
  componentId: "sc-2ip58c-0"
})(["display:", ";background:", ";border:1px solid ", ";box-shadow:1px 1px 1px rgba(0,0,0,0.15);width:", ";height:", ";padding:", ";margin:", ";border-radius:", ";min-width:0;"], function (props) {
  return props.display;
}, function (props) {
  return props.background || props.theme.colors.colorBase;
}, function (props) {
  return props.theme.colors.background;
}, function (props) {
  return props.width || 'auto';
}, function (props) {
  return props.height || 'auto';
}, function (props) {
  return props.padding || '45px 0 20px';
}, function (props) {
  return props.margin || '0';
}, function (props) {
  return props.borderRadius || '5px';
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Link = styled__default["default"](reactRouterDom.Link).withConfig({
  displayName: "Link",
  componentId: "sc-ov2n3x-0"
})(["color:", ";font-family:", ";font-size:1em;&:hover{color:", ";}"], function (props) {
  return props.theme.colors.linkColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return polished.darken(0.2, props.theme.colors.linkColor);
});

var BaseButton = function BaseButton(props) {
  var Component = props.to ? Link : 'button';
  var type = Component === 'button' ? props.type || 'button' : undefined;
  var loading = '';

  if (props.loading) {
    loading = /*#__PURE__*/React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      icon: freeSolidSvgIcons.faCircleNotch,
      fixedWidth: true,
      spin: true
    });
  }

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$2({}, props, {
    type: type
  }), loading, " ", props.children);
};

var Button = styled__default["default"](BaseButton).withConfig({
  displayName: "Button",
  componentId: "sc-18m7g4b-0"
})(["background:", ";color:", ";cursor:pointer;font-family:", ";font-size:1rem;line-height:1.75rem;margin:", ";padding:", ";border:2px solid transparent;border-radius:", ";position:relative;display:inline-block;text-decoration:none;align-self:flex-start;width:", ";transition:background .1s ease-in,box-shadow .1s ease-out,width .1s ease-in;&:hover{color:", ";background:", "}&:focus{box-shadow:0 0 0 3px ", ";}"], function (props) {
  if (props.active) return props.theme.colors.active;
  if (props.primary) return props.theme.colors.primary;
  if (props.danger) return props.theme.colors.danger;
  if (props.light) return props.theme.colors.bgBtnLight;
  if (props.dark) return props.theme.colors.bgBtnDark;
  if (props.secondary) return props.theme.colors.bgBtnSecondary;
  if (props.tertiary) return props.theme.colors.bgBtnTertiary;
  if (props.icon) return 'none';
  return props.theme.colors.bgBtnDefault;
}, function (props) {
  if (props.active) return 'white';
  if (props.primary) return 'white';
  if (props.danger) return 'white';
  if (props.light) return props.theme.colors.active;
  if (props.dark) return props.theme.colors.grayLight;
  if (props.loading) return polished.transparentize(0.3, props.theme.colors.primary);
  if (props.secondary) return 'white';
  if (props.tertiary) return 'white';
  if (props.icon) return props.theme.colors.active;
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.margin || '10px 10px 10px 0';
}, function (props) {
  return props.padding || '5px 10px';
}, function (props) {
  return props.icon ? '50%' : props.theme.borderRadius;
}, function (props) {
  if (props.block) return '100%';
  return 'auto';
}, function (props) {
  if (props.active) return 'white';
  if (props.primary) return 'white';
  if (props.danger) return 'white';
  if (props.light) return props.theme.colors.active;
  if (props.dark) return props.theme.colors.grayLight;
  if (props.loading) return polished.transparentize(0.3, props.theme.colors.primary);
  if (props.secondary) return 'white';
  if (props.tertiary) return 'white';
  if (props.icon) return props.theme.colors.active;
  return props.theme.colors.primary;
}, function (props) {
  if (!props.loading) {
    if (props.active) return polished.darken(0.2, props.theme.colors.active);
    if (props.primary) return polished.darken(0.2, props.theme.colors.primary);
    if (props.danger) return polished.darken(0.1, props.theme.colors.danger);
    if (props.light || props.icon) return polished.darken(0.1, props.theme.colors.bgBtnLight);
    if (props.dark) return polished.darken(0.1, props.theme.colors.primaryDarker);
    if (props.secondary) return polished.darken(0.1, props.theme.colors.bgBtnSecondary);
    if (props.tertiary) return polished.darken(0.1, props.theme.colors.bgBtnTertiary);
    return polished.darken(0.05, '#E0E6EE');
  }
}, function (props) {
  if (props.active) return polished.transparentize(0.7, polished.darken(0.2, props.theme.colors.active));
  if (props.primary) return polished.transparentize(0.7, polished.darken(0.2, props.theme.colors.primary));
  if (props.danger) return polished.transparentize(0.7, polished.darken(0.1, props.theme.colors.danger));
  if (props.light) return polished.transparentize(0.7, polished.darken(0.2, props.theme.colors.active));
  if (props.dark) return polished.transparentize(0.7, polished.darken(0.1, props.theme.colors.primaryDarker));
  return polished.transparentize(0.4, polished.darken(0.15, '#E0E6EE'));
});
BaseButton.propTypes = {
  to: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool
};

function BaseButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className || undefined
  }, children);
}

var ButtonGroup = styled__default["default"](BaseButtonGroup).withConfig({
  displayName: "ButtonGroup",
  componentId: "sc-fp3bsr-0"
})(["> div{display:inline-block;}> button{border-radius:0;margin-right:1px;}> button:first-child{border-radius:5px 0 0 5px;}> button:last-child{border-radius:0 5px 5px 0;}"]);

var _excluded$7 = ["hero", "children"];
var CardWrapper = styled__default["default"].div.withConfig({
  displayName: "Card__CardWrapper",
  componentId: "sc-99zkpd-0"
})(["background:white;border-radius:", ";display:flex;flex-direction:column;width:100%;margin:", ";"], function (props) {
  return props.borderRadius || props.theme.borderRadius;
}, function (props) {
  return props.marginTop ? props.marginTop : '0.5em 0';
});
var CardHero = styled__default["default"].div.withConfig({
  displayName: "Card__CardHero",
  componentId: "sc-99zkpd-1"
})(["display:block;overflow:hidden;width:100%;border-radius:5px 5px 0 0;"]);
var CardContent = styled__default["default"].div.withConfig({
  displayName: "Card__CardContent",
  componentId: "sc-99zkpd-2"
})(["padding:", ";"], function (props) {
  return props.padding || '25px';
});

function Card(_ref) {
  var hero = _ref.hero,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React__namespace.createElement(CardWrapper, rest, /*#__PURE__*/React__namespace.createElement(CardHero, null, hero), /*#__PURE__*/React__namespace.createElement(CardContent, {
    padding: rest === null || rest === void 0 ? void 0 : rest.padding
  }, children));
}

var _excluded$6 = ["label", "id", "light", "checked", "disabled", "inlineTable", "inlineTableHeading"];
var CheckboxContainer = styled__default["default"].label.withConfig({
  displayName: "Checkbox__CheckboxContainer",
  componentId: "sc-y1y1ra-0"
})(["display:", ";vertical-align:bottom;align-items:center;margin-left:", ""], function (props) {
  return props.inlineTableHeading ? 'flex' : 'inline-block';
}, function (props) {
  return props.inlineTable ? '1em' : 'auto';
});
var Icon = styled__default["default"].svg.withConfig({
  displayName: "Checkbox__Icon",
  componentId: "sc-y1y1ra-1"
})(["fill:none;"]); // Hide checkbox visually but remain accessible to screen readers.

var HiddenCheckbox = styled__default["default"].input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Checkbox__HiddenCheckbox",
  componentId: "sc-y1y1ra-2"
})(["", ";"], polished.hideVisually());
var CheckboxLabel = styled__default["default"].label.withConfig({
  displayName: "Checkbox__CheckboxLabel",
  componentId: "sc-y1y1ra-3"
})(["font-family:", ";font-size:1rem;text-align:left;display:inline-block;margin-left:8px;vertical-align:top;", " ", ""], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.light && styled.css(["color:", ";"], props.theme.colors.grayLight);
}, function (props) {
  return props.disabled && styled.css(["color:", ";"], props.theme.colors.grayLight);
});
var StyledCheckbox = styled__default["default"].div.withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-y1y1ra-4"
})(["display:inline-block;width:16px;height:16px;background:", ";border-radius:2px;transition:all 150ms;border:2px solid ", ";.fa-check{color:", ";}&:hover{cursor:", ";background:", ";}", " ", "{visibility:", "}"], function (props) {
  return props.checked ? props.theme.colors.active : props.theme.colors.colorBase;
}, function (props) {
  return props.checked ? polished.darken(0.1, props.theme.colors.active) : props.theme.colors.grayLighter;
}, function (props) {
  return props.theme.colors.colorBase;
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
}, function (props) {
  return props.checked ? polished.darken(0.1, props.theme.colors.active) : props.theme.colors.background;
}, function (props) {
  return props.disabled && styled.css(["opacity:0.7;"]);
}, Icon, function (props) {
  return props.checked ? 'visible' : 'hidden';
});

function Checkbox(_ref) {
  var label = _ref.label,
      id = _ref.id,
      _ref$light = _ref.light,
      light = _ref$light === void 0 ? false : _ref$light,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$inlineTable = _ref.inlineTable,
      inlineTable = _ref$inlineTable === void 0 ? false : _ref$inlineTable,
      _ref$inlineTableHeadi = _ref.inlineTableHeading,
      inlineTableHeading = _ref$inlineTableHeadi === void 0 ? false : _ref$inlineTableHeadi,
      rest = _objectWithoutProperties(_ref, _excluded$6);

  return /*#__PURE__*/React__namespace.createElement(CheckboxContainer, {
    inlineTable: inlineTable,
    inlineTableHeading: inlineTableHeading
  }, /*#__PURE__*/React__namespace.createElement(HiddenCheckbox, _extends$2({
    checked: checked
  }, rest)), /*#__PURE__*/React__namespace.createElement(StyledCheckbox, {
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/React__namespace.createElement(Icon, {
    viewBox: "0 1 24 24"
  }, /*#__PURE__*/React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faCheck
  }))), /*#__PURE__*/React__namespace.createElement(CheckboxLabel, {
    htmlFor: id,
    light: light,
    disabled: disabled
  }, label));
}

// https://medium.com/styled-components/how-to-create-responsive-ui-with-styled-components-c6b71a3ce172

var getWidth = function getWidth(span) {
  if (!span) return;
  var width = span / 12 * 100;
  return "".concat(width, "%");
};

var Col = styled__default["default"].div.withConfig({
  displayName: "Col",
  componentId: "sc-mdo22j-0"
})(["display:flex;flex-direction:", ";flex:", ";align-items:", ";justify-content:", ";padding:", ";margin:", ";min-width:0;height:100%;background:", ";", " ", " ", " ", " ", " ", ""], function (props) {
  return props.direction || 'column';
}, function (props) {
  return props.flex || '1';
}, function (props) {
  return props.align || 'stretch';
}, function (props) {
  return props.justify || 'flex-start';
}, function (props) {
  return props.padding || '0 15px 0 0';
}, function (props) {
  return props.margin || '0';
}, function (props) {
  if (props.light) return props.theme.colors.grayLighter;
  if (props.dark) return props.theme.colors.grayDarker;
  return 'none';
}, function (_ref) {
  var xs = _ref.xs;
  return xs && styled.css(["@media ", "{flex:0 0 ", ";}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.devices.mobile;
  }, getWidth(xs));
}, function (_ref3) {
  var sm = _ref3.sm;
  return sm && styled.css(["@media ", "{flex:0 0 ", ";max-width:", ";}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.devices.mobileL;
  }, getWidth(sm), getWidth(sm));
}, function (_ref5) {
  var md = _ref5.md;
  return md && styled.css(["@media ", "{flex:0 0 ", ";max-width:", ";}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.devices.tablet;
  }, getWidth(md), getWidth(md));
}, function (_ref7) {
  var lg = _ref7.lg;
  return lg && styled.css(["@media ", "{flex:0 0 ", ";max-width:", ";}"], function (_ref8) {
    var theme = _ref8.theme;
    return theme.devices.laptop;
  }, getWidth(lg), getWidth(lg));
}, function (_ref9) {
  var xl = _ref9.xl;
  return xl && styled.css(["@media ", "{flex:0 0 ", ";max-width:", ";}"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.devices.desktop;
  }, getWidth(xl), getWidth(xl));
}, function (_ref11) {
  var xxl = _ref11.xxl;
  return xxl && styled.css(["@media ", "{flex:0 0 ", ";max-width:", ";}"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.devices.desktopL;
  }, getWidth(xxl), getWidth(xxl));
});

function Collapse(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: "collapse"
  }, children);
}

var Content = styled__default["default"].div.withConfig({
  displayName: "Content",
  componentId: "sc-1obl712-0"
})(["background:", ";display:flex;flex-direction:column;width:100%;min-width:0;min-height:100vh;"], function (props) {
  return props.theme.colors.background;
});

var Container = styled__default["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-1g9zgmm-0"
})(["width:100%;margin-left:auto;margin-right:auto;padding:0 ", ";"], function (props) {
  return props.containerGutter || props.theme.containerGutter;
});

var Text = styled__default["default"].span.withConfig({
  displayName: "Text",
  componentId: "sc-nkpf3w-0"
})(["font-family:", ";font-size:", ";padding:", ";margin:", ";color:", ";vertical-align:", ";", " ", ""], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.size || props.theme.fontSizes.base;
}, function (props) {
  return props.padding || '0';
}, function (props) {
  return props.margin || '0';
}, function (props) {
  return props.color || props.theme.colors.textPrimary;
}, function (props) {
  return props.verticalAlign || 'baseline';
}, function (props) {
  return props.highlight && styled.css(["color:", ";"], function (props) {
    return props.theme.colors.active;
  });
}, function (props) {
  return props.strong && styled.css(["font-weight:bold;"]);
});

var DropdownWrapper = styled__default["default"].div.withConfig({
  displayName: "Dropdown__DropdownWrapper",
  componentId: "sc-wqakwk-0"
})(["position:relative;width:", ";display:", ";.inner{width:", ";}.ddHeader:hover{background:", "}.open .ddHeader{border-radius:", " ", " 0 0;color:#fff;background:", ";}button.ddHeader .ddHeaderText,button.ddHeader .ddHeaderText span{color:", ";}.open .ddHeader .ddHeaderText,.open .ddHeader .ddHeaderText span{color:#fff;}.open.up .ddHeader{border-radius:0 0 ", " ", ";}button.dd-list-item,button.ddHeader{overflow:visible;width:inherit;margin:inherit;padding:inherit;border:none;background:inherit;font:inherit;line-height:normal;color:inherit;text-align:inherit;}transition:background .1s ease-in,box-shadow .1s ease-out,width .1s ease-in;.open .ddHeader:hover{background:", ";}.dd-list{position:absolute;z-index:10;width:auto;min-width:100%;border-radius:0 0 ", " ", ";background-color:white;text-align:left;-webkit-overflow-scrolling:touch;}.open .dd-list{border:2px solid ", ";}button.dd-list-item{display:inline-block;width:100%;padding:10px;line-height:1.6rem;overflow:hidden;cursor:pointer;color:#000;background-color:#fff;white-space:nowrap;text-overflow:ellipsis;padding-left:25px;}.dd-list button.dd-list-item:last-child{border-radius:0 0 ", " ", ";}button.ddHeader{transition:background .1s ease-in,box-shadow .1s ease-out,width .1s ease-in;display:flex;align-items:center;justify-content:space-between;position:relative;padding:5px 10px;border-radius:", ";color:", ";background:", ";line-height:", ";min-height:", ";cursor:pointer;}.up .dd-list{bottom:100%;}.up.open .dd-list{border-radius:", " ", " 0 0;}.dd-scroll-list{overflow-y:auto;max-height:300px;}.dd-list-item.selected{padding-left:10px;}.dd-list-item:hover,.dd-list-item:hover .optionText{background-color:", ";color:white;}.dd-list-item svg{padding-right:5px;font-size:0.9rem;width:15px;}.up .ddHeader svg.fa-chevron-down,.up .ddHeader svg.fa-chevron-up{transform:scale(-1,-1)}.ddHeaderTitle{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}"], function (props) {
  return props.width;
}, function (props) {
  return props.block ? 'block' : 'inline-block';
}, function (props) {
  return props.width;
}, function (props) {
  if (props.dark) return polished.darken(0.1, props.theme.colors.primaryDarker);
  return polished.darken(0.05, '#E0E6EE');
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  if (props.dark) return props.theme.colors.grayLight;
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  if (props.dark) return props.theme.colors.grayLight;
  return props.theme.colors.primary;
}, function (props) {
  if (props.transparent) return 'transparent';
  if (props.dark) return props.theme.colors.bgBtnDark;
  return props.theme.colors.bgBtnDefault;
}, function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colors.linkColor;
});

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      title = _ref.title,
      options = _ref.options,
      up = _ref.up,
      dark = _ref.dark,
      height = _ref.height,
      width = _ref.width,
      block = _ref.block,
      rollout = _ref.rollout,
      selectedOptions = _ref.selectedOptions,
      onChange = _ref.onChange,
      iconUp = _ref.iconUp,
      iconDown = _ref.iconDown,
      transparent = _ref.transparent;

  var _useState = React.useState(rollout),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = React.useState(selectedOptions),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = React.useState(title),
      _useState6 = _slicedToArray(_useState5, 2),
      headerTitle = _useState6[0],
      setHeaderTitle = _useState6[1];

  React.useEffect(function () {
    if (selected.length > 0) {
      setHeaderTitle(options[selected[0]]);
    } // Call change callback


    if (onChange !== undefined) {
      onChange(selected);
    }
  }, [selected]);

  var toggleList = function toggleList(e) {
    setOpen(!open);
  };

  var select = function select(key) {
    setSelected([key]);
    setOpen(false);
  };

  var listItems = function listItems(callback) {
    return options.map(function (option, i) {
      return /*#__PURE__*/React__default["default"].createElement("button", {
        key: i,
        className: "dd-list-item ".concat(selected[0] === i ? 'selected' : ''),
        onClick: function onClick(e) {
          return select(i);
        }
      }, selected[0] === i ? /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faCheck,
        fixedWidth: true
      }) : '', /*#__PURE__*/React__default["default"].createElement(Text, {
        className: "optionText"
      }, option));
    });
  };

  var header = function header() {
    var iconUpElement = iconUp || /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: freeSolidSvgIcons.faChevronUp,
      fixedWidth: true
    });
    var iconDownElement = iconDown || /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: freeSolidSvgIcons.faChevronDown,
      fixedWidth: true
    });
    return /*#__PURE__*/React__default["default"].createElement("button", {
      className: "ddHeader",
      type: "button",
      onClick: function onClick() {
        return toggleList();
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "ddHeaderTitle"
    }, /*#__PURE__*/React__default["default"].createElement(Text, {
      className: "ddHeaderText"
    }, headerTitle)), open ? iconUpElement : iconDownElement);
  };

  var handleBlur = function handleBlur(e) {
    var currentTarget = e.currentTarget; // Check the newly focused element in the next tick of the event loop

    setTimeout(function () {
      // Check if the new activeElement is a child of the original container
      if (!currentTarget.contains(document.activeElement)) {
        setOpen(false);
      }
    }, 0);
  };

  return /*#__PURE__*/React__default["default"].createElement(DropdownWrapper, {
    onBlur: handleBlur,
    transparent: transparent,
    dark: dark,
    height: height,
    width: width,
    block: block
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "inner ".concat(open ? 'open' : '', " ").concat(up ? 'up' : '')
  }, !up && header(), !children && open && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "dd-list"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "dd-scroll-list"
  }, listItems())), children && open && /*#__PURE__*/React__default["default"].createElement("div", {
    className: "dd-list"
  }, children), up && header()));
};

Dropdown.propTypes = {
  title: PropTypes.node,
  options: PropTypes.array,
  children: PropTypes.node,
  up: PropTypes.bool,
  block: PropTypes.bool,
  dark: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  rollout: PropTypes.bool,
  selectedOptions: PropTypes.array,
  onChange: PropTypes.func,
  iconUp: PropTypes.node,
  iconDown: PropTypes.node,
  transparent: PropTypes.bool
};
Dropdown.defaultProps = {
  title: 'Test',
  options: [],
  selectedOptions: [],
  block: false,
  dark: false,
  width: '200px',
  height: '28px',
  rollout: false,
  transparent: false
};

var Footer = styled__default["default"].footer.withConfig({
  displayName: "Footer",
  componentId: "sc-nsfp28-0"
})(["background:white;text-align:left;padding:15px 40px;min-height:80px;flex:0 0 auto;", ""], function (props) {
  return props.dark && styled.css(["background:black;color:#aaa;p{color:inherit;}"]);
});

var Header = styled__default["default"].div.withConfig({
  displayName: "Header",
  componentId: "sc-tgq1j5-0"
})(["background:white;text-align:left;padding:", ";flex-direction:row;display:flex;min-height:", ";"], function (props) {
  return props.padding || '2em';
}, function (props) {
  return props.minHeight || 'auto';
});

var InputLabel = styled__default["default"].label.withConfig({
  displayName: "InputLabel",
  componentId: "sc-lno4po-0"
})(["font-family:", ";font-size:1rem;font-weight:bold;text-align:left;margin-bottom:5px;display:flex;flex-direction:row;"], function (props) {
  return props.theme.fontFamily;
});

var _excluded$5 = ["id", "label", "required", "hideAsterisk"];
var InputText = styled__default["default"].input.withConfig({
  displayName: "Input__InputText",
  componentId: "sc-10uszsd-0"
})(["font-family:", ";font-size:1rem;background-color:#F9F9F9;border-radius:", ";border:1px solid ", ";padding:10px 20px;transition:all .2s,height 0s,width 0s;&:hover{border:1px solid ", ";}&:focus{border:1px solid ", ";box-shadow:0 0 0 2px ", ";}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus,&:-webkit-autofill:active{transition:#fff 5000s ease-in-out 0s;}filter:none;", " ", ""], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.borderColour ? props.borderColour : '#F9F9F9';
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return polished.transparentize(0.7, props.theme.colors.active);
}, function (props) {
  return props.disabled && styled.css(["opacity:0.8;cursor:not-allowed;"]);
}, function (props) {
  return props.fullwidth && styled.css(["display:block;margin-bottom:", ";width:100%;"], props.marginBottom ? props.marginBottom : '2rem');
});
var InputWrapper = styled__default["default"].div.withConfig({
  displayName: "Input__InputWrapper",
  componentId: "sc-10uszsd-1"
})(["margin:0;"]);

function InputBase(_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$hideAsterisk = _ref.hideAsterisk,
      hideAsterisk = _ref$hideAsterisk === void 0 ? false : _ref$hideAsterisk,
      rest = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React__namespace.createElement(InputWrapper, null, /*#__PURE__*/React__namespace.createElement(InputLabel, {
    htmlFor: id
  }, label, " ", required && !hideAsterisk && /*#__PURE__*/React__namespace.createElement("span", null, "*")), /*#__PURE__*/React__namespace.createElement(InputText, _extends$2({
    "arial-label": label,
    "arial-required": required,
    ref: ref
  }, rest)));
}

var Input = /*#__PURE__*/React__namespace.forwardRef(InputBase);

function BaseInputGroup(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: className
  }, children);
}

var InputGroup = styled__default["default"](BaseInputGroup).withConfig({
  displayName: "InputGroup",
  componentId: "sc-t2d5oi-0"
})(["> div{display:inline-block;}> div input,> button{border-radius:0;}>:first-child input{border-radius:5px 0 0 5px;}> button:last-child{border-radius:0 5px 5px 0;}"]);

var _excluded$4 = ["items"];
var ListWrapper = styled__default["default"].ul.withConfig({
  displayName: "List__ListWrapper",
  componentId: "sc-1qcycjw-0"
})(["margin:0;padding-left:", ";text-align:left;width:100%;li{padding:0.5em 0;line-height:1.4rem;.title{display:inline-block;margin-right:10px;}.label{display:inline-block;background:", ";color:", ";font-size:0.9em;border:1px solid ", ";border-radius:", ";line-height:120%;padding:2px 8px;a:hover{text-decoration:underline;}}", "}"], function (props) {
  return props.simple ? '10px' : '0';
}, function (props) {
  return props.theme.colors.danger;
}, function (props) {
  return props.theme.colors.colorBase;
}, function (props) {
  return props.theme.colors.danger;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return !props.simple && styled.css(["list-style:none;border-bottom:1px solid ", ";padding:1em 0;display:flex;align-items:top;.left{flex:3;}.right{flex:1;text-align:right;}"], function (props) {
    return props.theme.colors.grayLightest;
  });
});

function List(_ref) {
  var items = _ref.items,
      rest = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React__namespace.createElement(ListWrapper, rest, items.map(function (item, index) {
    return /*#__PURE__*/React__namespace.createElement("li", {
      key: index
    }, /*#__PURE__*/React__namespace.createElement("div", {
      className: "left"
    }, /*#__PURE__*/React__namespace.createElement("div", {
      className: "title"
    }, item.url ? /*#__PURE__*/React__namespace.createElement(Link, {
      to: "".concat(item.url)
    }, item.title) : item.title), item.label ? /*#__PURE__*/React__namespace.createElement(Link, {
      to: "".concat(item.labelURL)
    }, /*#__PURE__*/React__namespace.createElement("div", {
      className: "label"
    }, item.label)) : ''), item.secondary ? /*#__PURE__*/React__namespace.createElement("div", {
      className: "right"
    }, item.secondary) : '');
  }));
}

List.propTypes = {
  items: PropTypes.array,
  simple: PropTypes.bool
};

var _path, _path2, _path3;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgIxLogo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.8 42.7"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.3 33.8s-7.3 3.3-16.8-2.1-9.1 4.2-7.2 6.6C13.6 41 16.9 43.1 23 42c6.1-1.1 12.3-8.2 12.3-8.2z",
    fill: "#81848a"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M109.4 23.3l-5.9-10.9h5l3.5 7.5 3.7-7.5h4.9l-5.9 10.9 6.1 11.7h-4.9l-4-8.4-4 8.4h-4.8l6.3-11.7zM7 8.5s7.3-3.3 16.8 2.1S32.9 6.4 31 4C28.8 1.2 25.4-.9 19.3.3 13.2 1.4 7 8.5 7 8.5zM33.5 7s3.3 7.3-2.1 16.8 4.2 9.1 6.6 7.2c2.8-2.2 4.9-5.6 3.7-11.7C40.6 13.2 33.5 7 33.5 7z",
    fill: "#ef3829"
  })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M50.4 4.9h4.8V35h-4.8V4.9zm7.8 7.4h4.3V15h.1c1.1-2 3.3-3.2 5.8-3.2 3.5 0 5.6 1.6 5.6 6.1V35h-4.5V19.5c0-2.9-.9-4.1-3.2-4.1-1.9 0-3.6 1.5-3.6 4.4V35h-4.5V12.3zm20.2 3.4h-3.2v-3.4h3.2v-2.1c0-4.3 2.1-5.6 5.8-5.6 1 0 1.8 0 2.5.1v3.5h-1.3c-1.7 0-2.4.6-2.4 2.1v2h3.7v3.4H83V35h-4.5V15.7zm16.3-3.9c6.6 0 8.5 4.9 8.5 11.9s-2.1 11.9-8.5 11.9c-6.3 0-8.4-4.9-8.4-11.9s1.9-11.9 8.4-11.9zm0 20.4c3.3 0 3.9-2.8 3.9-8.5 0-5-.6-8.5-3.9-8.5s-3.9 3.5-3.9 8.5c.1 5.7.7 8.5 3.9 8.5zm42.3-5.5c-.3 5.4-2.1 8.8-7.7 8.8-6.6 0-8.4-4.9-8.4-11.9s1.9-11.9 8.4-11.9c6.8-.1 7.8 5.3 7.8 8.1h-4.5c0-2.1-.6-4.8-3.2-4.8-3.3 0-3.9 3.5-3.9 8.5s.6 8.5 3.9 8.5c2.5 0 3.5-2.1 3.5-5.5h4.1zm1.7-21.8h4.5v9.9l.1.1c1.3-1.9 3.2-3.1 5.6-3.1 3.5 0 5.6 1.6 5.6 6.1V35H150V19.5c0-2.9-.9-4.1-3.2-4.1-1.9 0-3.6 1.5-3.6 4.4V35h-4.5V4.9zm33.6 25.4c0 .8.5 1.6 1.2 1.6.3 0 .6 0 .8-.1v2.9c-.5.3-1.3.5-2.2.5-2 0-3.7-.8-3.8-3h-.1c-1.2 2.2-3 3.3-5.6 3.3-3.6 0-5.9-2-5.9-6.4 0-5.1 2.2-6.1 5.3-7.1l3.5-1c1.6-.5 2.7-.9 2.7-2.9 0-2.1-.7-3.4-3.1-3.4-3 0-3.5 2.1-3.5 4.3h-4.3c0-4.8 2-7.5 8-7.5 4 0 7.2 1.6 7.2 5.6v13.2zM168 23c-1.2.9-3.7 1.5-5.1 2.1-1.3.6-1.9 2-1.9 3.7 0 1.9.9 3.4 2.8 3.4 2.7 0 4.1-2.1 4.1-5.4V23zm7.5-10.7h4.3V15h.1c1.1-2 3.3-3.2 5.8-3.2 3.5 0 5.6 1.6 5.6 6.1V35h-4.5V19.5c0-2.9-.9-4.1-3.2-4.1-1.9 0-3.6 1.5-3.6 4.4V35h-4.5V12.3zm23.3 24.6c0 1.4 1.3 2.7 3.3 2.7 2.4 0 3.8-1.6 3.8-4.3v-3.7h-.1c-.8 2-2.9 3.1-5.1 3.1-5.3 0-6.8-5.2-6.8-11.4 0-5 .8-11.7 7.2-11.7 2.7 0 4.5 1.7 5 3.4h.1v-2.8h4.3v21.6c0 5.5-2.4 8.8-8.5 8.8-6.7 0-7.5-4-7.5-5.8h4.3zm3.2-5.7c3.5 0 3.9-4.5 3.9-8 0-3.7-.5-7.8-3.6-7.8-3.3 0-3.8 3.4-3.8 7.6 0 3.8.1 8.2 3.5 8.2zm14.9-6.9v1.3c0 3 .4 6.9 3.8 6.9 3.2 0 3.6-3.7 3.6-5.1h4.3c0 5-3 8.2-8 8.2-3.7 0-8.3-1.1-8.3-11.6 0-5.9 1.3-12.3 8.4-12.3 6.3 0 8 3.8 8 10.1v2.4h-11.8zm7.3-3.2v-1.2c0-2.9-.9-5.1-3.5-5.1-2.9 0-3.8 2.9-3.8 5.8v.5h7.3zM8.5 34.8S5.2 27.5 10.6 18 6.4 8.9 4 10.8C1.3 13-.8 16.4.3 22.5c1.1 6.1 8.2 12.3 8.2 12.3z"
  })));
}

var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgIxLogoCompact(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.86 80.37"
  }, props), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, ".ix-logo-compact_svg__cls-2{fill:#ee352a}"))), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
    id: "ix-logo-compact_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    id: "ix-logo-compact_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M67.15 64.21s-13.83 6.2-31.94-4.08-17.33 8-13.68 12.55c4.23 5.27 10.65 9.23 22.19 7.11s23.43-15.58 23.43-15.58z",
    fill: "#8b8d8e"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "ix-logo-compact_svg__cls-2",
    d: "M13.22 16.16S27.05 10 45.16 20.24s17.33-8 13.68-12.55C54.6 2.42 48.18-1.53 36.64.58S13.22 16.16 13.22 16.16z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    className: "ix-logo-compact_svg__cls-2",
    d: "M63.7 13.22s6.2 13.83-4.08 31.94 8 17.33 12.55 13.68c5.27-4.23 9.23-10.65 7.11-22.19S63.7 13.22 63.7 13.22z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.16 66.12S10 52.29 20.24 34.18s-8-17.33-12.55-13.68C2.42 24.74-1.54 31.16.58 42.69s15.58 23.43 15.58 23.43z"
  })))));
}

var LogoImage = styled__default["default"].div.withConfig({
  displayName: "Logo__LogoImage",
  componentId: "sc-1u7fcsh-0"
})(["display:block;margin:20px;text-align:center;svg{max-height:50px;fill:", ";path{fill:", ";}}"], function (props) {
  return props.inverse ? 'white' : 'auto';
}, function (props) {
  return props.inverse ? 'white' : 'auto';
});

function Logo(_ref) {
  var _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse;
  return /*#__PURE__*/React__default["default"].createElement(LogoImage, {
    inverse: inverse
  }, compact ? /*#__PURE__*/React__default["default"].createElement(SvgIxLogoCompact, null) : /*#__PURE__*/React__default["default"].createElement(SvgIxLogo, null));
}

var Menu = styled__default["default"].ul.withConfig({
  displayName: "Menu",
  componentId: "sc-jywv9l-0"
})(["text-align:left;padding:0;ul{padding:0;}li a{padding-left:30px;}", " ", ""], function (props) {
  return props.type === 'horizontal' && styled.css(["li{display:inline-block;a{padding-left:20px;padding-right:20px;}}"]);
}, function (props) {
  return props.dark && styled.css(["text-shadow:1px 1px rgba(0,0,0,0.5);li a{color:#aaa;}li a:hover{color:#fff;}li a:active{background-color:rgba(20,20,20,0.5);}"]);
});

var MenuItem = styled__default["default"].li.withConfig({
  displayName: "MenuItem",
  componentId: "sc-1c3w1nc-0"
})(["font-family:", ";font-size:14px;text-align:left;color:#aaa;list-style:none;cursor:pointer;transition:color .2s ease-in;padding-left:", ";&:hover{color:", ";}& svg{margin-right:10px;color:#aaa;transition:color .2s ease-in;}& a{display:block;width:100%;padding-top:10px;padding-bottom:10px;color:#666;transition:color .2s ease-in;text-decoration:none;}& a:hover,& a:focus{color:", ";svg{color:", ";}}& a:active,& a.active{color:", ";svg{color:", ";}}"], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.submenu ? '2em' : '0';
}, function (props) {
  return polished.darken(0.2, props.theme.colors.linkColor);
}, function (props) {
  return props.theme.colors.linkColor;
}, function (props) {
  return props.theme.colors.linkColor;
}, function (props) {
  return props.theme.colors.grayLightest;
}, function (props) {
  return props.theme.colors.linkColor;
});

var Page = styled__default["default"].div.withConfig({
  displayName: "Page",
  componentId: "sc-10od8hk-0"
})(["width:100%;height:100%;margin:auto;text-align:center;display:flex;background:", ";@media ", "{max-width:100%;}@media ", "{max-width:100%;}"], function (props) {
  return props.theme.colors.background;
}, function (props) {
  return props.theme.devices.laptop;
}, function (props) {
  return props.theme.devices.desktop;
});

/* eslint-enable no-unused-vars */

var PaginationList = styled__default["default"].ul.withConfig({
  displayName: "Pagination__PaginationList",
  componentId: "sc-j206vs-0"
})(["padding:0;margin:10px 0 0 0;"]);
var PaginationPage = styled__default["default"].li.withConfig({
  displayName: "Pagination__PaginationPage",
  componentId: "sc-j206vs-1"
})(["display:inline-block;vertical-align:top;padding:0;margin:0;font-family:", ";a{display:inline-block;padding:10px 5px;color:", ";text-decoration:none;}a:hover{color:", ";}.fa-ellipsis-h{color:", ";font-size:0.8rem;}", " ", " ", " ", " ", ""], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.colors.grayDark;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.colors.grayLight;
}, function (props) {
  return props.currentPage && styled.css(["a{color:", ";}"], function (props) {
    return props.theme.colors.textPrimary;
  });
}, function (props) {
  return (props.prev || props.next) && styled.css(["a{background-color:", ";padding:10px;margin:0 5px;font-size:0.8rem;border:2px solid transparent;border-radius:", ";}"], function (props) {
    return props.theme.colors.bgBtnDefault;
  }, function (props) {
    return props.theme.borderRadius;
  });
}, function (props) {
  return props.prev && styled.css(["a{margin-left:0;}"]);
}, function (props) {
  return props.next && styled.css(["a{margin-right:0;}"]);
}, function (props) {
  return props.disabled && styled.css(["a,a:hover,a:focus{cursor:default;color:", ";}"], function (props) {
    return props.theme.colors.grayLight;
  });
});

function Pagination(props) {
  var total = props.total,
      showNumbers = props.showNumbers,
      showNextPrev = props.showNextPrev,
      pageSize = props.pageSize,
      pageNeighbours = props.pageNeighbours,
      showEndNumbers = props.showEndNumbers;
  var totalPages = Math.ceil(total / pageSize);

  var _useState = React.useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var gotoPage = function gotoPage(page) {
    var currentPage = Math.max(0, Math.min(page, totalPages));

    if (page > 0) {
      setPage(currentPage);
    }
  };

  React.useEffect(function () {
    var paginationData = {
      currentPage: page,
      totalPages: totalPages,
      pageSize: pageSize
    }; // Call onPageChange callback

    if (props.onPageChange !== undefined) {
      props.onPageChange(paginationData);
    }
  }, [page]);

  var handleClick = function handleClick(page) {
    return function (evt) {
      evt.preventDefault();
      gotoPage(page);
    };
  };

  var numbers = [];

  if (showNumbers) {
    numbers = Array(totalPages).fill(0).map(function (_, i) {
      var offsetEnd = 0;
      var offsetStart = 0;
      var startEllipsis = '';
      var endEllipsis = ''; // If the current page is within range of the end.

      if (page < pageNeighbours + 1) {
        offsetEnd = pageNeighbours - (page - 1);
      } // If we are in the middle of page numbers, show an '...' at either end.


      if (page - 1 > pageNeighbours + 1) {
        startEllipsis = /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: freeSolidSvgIcons.faEllipsisH,
          fixedWidth: true
        });
      }

      if (page - 1 < totalPages - pageNeighbours) {
        endEllipsis = /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
          icon: freeSolidSvgIcons.faEllipsisH,
          fixedWidth: true
        });
      } // If the current page is within range of the start.


      if (page > totalPages - pageNeighbours) {
        offsetStart = pageNeighbours - (totalPages - page);
      } // Page numbers.


      if (page - pageNeighbours - offsetStart <= i + 1 && page + pageNeighbours + offsetEnd >= i + 1) {
        return /*#__PURE__*/React__default["default"].createElement(PaginationPage, {
          key: i,
          currentPage: i + 1 === page ? true : ''
        }, /*#__PURE__*/React__default["default"].createElement("a", {
          href: '#page-' + (i + 1),
          onClick: handleClick(i + 1)
        }, i + 1));
      }

      if (showEndNumbers) {
        // Show last page.
        if (i + 1 === totalPages) {
          return /*#__PURE__*/React__default["default"].createElement(PaginationPage, {
            key: i,
            currentPage: i + 1 === page ? true : ''
          }, endEllipsis, /*#__PURE__*/React__default["default"].createElement("a", {
            href: '#page-' + (i + 1),
            onClick: handleClick(i + 1)
          }, i + 1));
        } // Show first page.


        if (i === 0) {
          return /*#__PURE__*/React__default["default"].createElement(PaginationPage, {
            key: i,
            currentPage: i + 1 === page ? true : ''
          }, /*#__PURE__*/React__default["default"].createElement("a", {
            href: '#page-' + (i + 1),
            onClick: handleClick(i + 1)
          }, i + 1), startEllipsis);
        }
      }

      return null;
    });
  }

  return /*#__PURE__*/React__default["default"].createElement("nav", {
    "aria-label": "pagination"
  }, /*#__PURE__*/React__default["default"].createElement(PaginationList, null, showNextPrev ? /*#__PURE__*/React__default["default"].createElement(PaginationPage, {
    prev: true,
    disabled: page <= 1 ? true : ''
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: "#prev",
    onClick: handleClick(page - 1)
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faChevronLeft,
    fixedWidth: true
  }))) : '', numbers, showNextPrev ? /*#__PURE__*/React__default["default"].createElement(PaginationPage, {
    next: true,
    disabled: page >= totalPages ? true : ''
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: "#next",
    onClick: handleClick(page + 1)
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faChevronRight,
    fixedWidth: true
  }))) : ''));
}

Pagination.propTypes = {
  total: PropTypes.number,
  pageNeighbours: PropTypes.number,
  pageSize: PropTypes.number,
  showEndNumbers: PropTypes.bool,
  showNextPrev: PropTypes.bool,
  showNumbers: PropTypes.bool,
  onPageChange: PropTypes.func
};
Pagination.defaultProps = {
  pageSize: 10,
  pageNeighbours: 1,
  showEndNumbers: true,
  showNextPrev: true,
  showNumbers: true
};

var Paragraph = styled__default["default"].p.withConfig({
  displayName: "Paragraph",
  componentId: "sc-k2y5cs-0"
})(["color:", ";font-family:", ";font-size:1rem;line-height:160%;padding:10px 0;text-align:left;"], function (props) {
  return props.theme.colors.textPrimary;
}, function (props) {
  return props.theme.fontFamily;
});

var Placeholder = styled__default["default"].div.withConfig({
  displayName: "Placeholder",
  componentId: "sc-q9ljs4-0"
})(["color:", ";font-family:", ";background-color:", ";font-size:14px;line-height:160%;padding:10px 0;text-align:left;width:100%;height:200px;"], function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.colors.primary;
});

var _excluded$3 = ["overdue", "pending", "final"];
var ProgressBarWrapper = styled__default["default"].div.withConfig({
  displayName: "ProgressBar__ProgressBarWrapper",
  componentId: "sc-1tboz7s-0"
})(["display:flex;overflow:hidden;height:5px;background-color:", ";margin:0.5em 0;.bar{flex-direction:column;justify-content:center;white-space:nowrap;}.final{background-color:", ";}.pending{background-color:", ";}.overdue{background-color:", ";}"], function (props) {
  return props.theme.colors.background;
}, function (props) {
  return props.theme.colors.success;
}, function (props) {
  return props.theme.colors.warning;
}, function (props) {
  return props.theme.colors.danger;
});

function ProgressBar(_ref) {
  var _ref$overdue = _ref.overdue,
      overdue = _ref$overdue === void 0 ? 0 : _ref$overdue,
      _ref$pending = _ref.pending,
      pending = _ref$pending === void 0 ? 0 : _ref$pending,
      _ref$final = _ref["final"],
      _final = _ref$final === void 0 ? 0 : _ref$final,
      rest = _objectWithoutProperties(_ref, _excluded$3);

  var total = parseInt(overdue) + parseInt(pending) + parseInt(_final);
  var overduePct = Math.floor(overdue / total * 100);
  var pendingPct = Math.floor(pending / total * 100);
  var finalPct = Math.floor(_final / total * 100);

  var ProgressBreakdown = function ProgressBreakdown(_ref2) {
    var width = _ref2.width,
        title = _ref2.title,
        className = _ref2.className;
    return /*#__PURE__*/React__namespace.createElement("div", {
      className: "bar ".concat(className),
      title: title,
      style: {
        width: "".concat(width, "%")
      }
    });
  };

  return /*#__PURE__*/React__namespace.createElement(ProgressBarWrapper, rest, overdue && /*#__PURE__*/React__namespace.createElement(ProgressBreakdown, {
    title: "overdue",
    width: overduePct,
    className: "overdue"
  }), pending && /*#__PURE__*/React__namespace.createElement(ProgressBreakdown, {
    title: "pending",
    width: pendingPct,
    className: "pending"
  }), _final && /*#__PURE__*/React__namespace.createElement(ProgressBreakdown, {
    title: "final",
    width: finalPct,
    className: "final"
  }));
}

function LoadingProgressBar(_ref) {
  var _ref$currentProgress = _ref.currentProgress,
      currentProgress = _ref$currentProgress === void 0 ? 0 : _ref$currentProgress;
  var theme = styled.useTheme();
  return /*#__PURE__*/React__namespace.createElement("div", null, /*#__PURE__*/React__namespace.createElement(ProgressBar__default["default"], {
    completed: currentProgress,
    maxCompleted: 100,
    bgColor: theme.colors.active,
    baseBgColor: theme.colors.background,
    borderRadius: "3px"
  }));
}

var _excluded$2 = ["checked", "disabled", "label"];
var RadioButtonContainer = styled__default["default"].label.withConfig({
  displayName: "RadioButton__RadioButtonContainer",
  componentId: "sc-4oar8s-0"
})(["height:auto;width:100%;padding:0px 10px 15px 10px;line-height:1.1;display:grid;grid-template-columns:1rem auto;gap:0.5rem;*,*:before,*:after{box-sizing:border-box;}"]);
var RadioButtonInput = styled__default["default"].input.withConfig({
  displayName: "RadioButton__RadioButtonInput",
  componentId: "sc-4oar8s-1"
})(["-webkit-appearance:none;appearance:none;background-color:#fff;margin:0;font:inherit;width:1.15rem;height:1.15rem;border:0.15rem solid ", ";border-radius:50%;transform:translateY(-0.075rem);min-width:1.15rem;display:grid;place-content:center;&::before{content:\"\";width:0.65rem;height:0.65rem;border-radius:50%;transform:scale(0);transition:60ms transform ease-in-out;box-shadow:inset 1rem 1rem ", ";}&:checked::before{transform:scale(1);}&:focus{border:1px solid ", ";}&:focus-visible{outline:1px solid #fff;background:", ";}&:checked{border:0.15rem solid ", ";}&:hover{cursor:", ";background:", ";}&:disabled{opacity:0.7;}"], function (props) {
  return props.theme.colors.grayLighter;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return polished.lighten(0.2, props.theme.colors.active);
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
}, function (props) {
  return props.disabled ? 'none' : polished.lighten(0.02, props.theme.colors.grayLighter);
});
var RadioButtonLabel = styled__default["default"].label.withConfig({
  displayName: "RadioButton__RadioButtonLabel",
  componentId: "sc-4oar8s-2"
})(["font-family:", ";font-size:1rem;text-align:left;margin-left:8px;", ""], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.disabled && styled.css(["color:", ";"], props.theme.colors.grayLight);
});

function RadioButton(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var radioButtonId = label.replace(/ /g, '_');
  return /*#__PURE__*/React__namespace.createElement(RadioButtonContainer, null, /*#__PURE__*/React__namespace.createElement(RadioButtonInput, _extends$2({
    type: "radio",
    checked: checked,
    disabled: disabled,
    id: radioButtonId
  }, rest)), /*#__PURE__*/React__namespace.createElement(RadioButtonLabel, {
    disabled: disabled,
    "for": radioButtonId
  }, label));
}

// https://medium.com/styled-components/how-to-create-responsive-ui-with-styled-components-c6b71a3ce172
var Row = styled__default["default"].div.withConfig({
  displayName: "Row",
  componentId: "sc-r8cet1-0"
})(["display:flex;min-width:0;flex-wrap:wrap;align-items:", ";justify-content:", ";width:100%;padding:", ";background:", ";border-radius:", ";"], function (props) {
  return props.align || 'stretch';
}, function (props) {
  return props.justify || 'flex-start';
}, function (props) {
  return props.padding || '0';
}, function (props) {
  return props.background || 'inherited';
}, function (props) {
  return props.borderRadius || '0';
});

var Section = styled__default["default"].div.withConfig({
  displayName: "Section",
  componentId: "sc-fpeth1-0"
})(["padding:30px ", ";text-align:left;flex-shrink:0;flex-grow:1;background:", " url(", ") no-repeat center center fixed;background-size:cover;"], function (props) {
  return props.sectionGutter || props.theme.sectionGutter;
}, function (props) {
  return props.background;
}, function (props) {
  return props.backgroundImage;
});

var SidebarInner = styled__default["default"].div.withConfig({
  displayName: "Sidebar__SidebarInner",
  componentId: "sc-vncq2c-0"
})(["background:", ";width:210px;top:0;"], function (props) {
  return props.theme.colors.bgSidebar;
});
var StyledSidebar = styled__default["default"].div.withConfig({
  displayName: "Sidebar__StyledSidebar",
  componentId: "sc-vncq2c-1"
})(["background:", ";flex-shrink:0;flex-basis:210px;position:relative;.collapse{position:static;}@media ", "{flex-basis:auto;display:none;}@media ", "{flex-basis:210px;", " display:block;}", ""], function (props) {
  return props.theme.colors.bgSidebar;
}, function (props) {
  return props.theme.devices.mobile;
}, function (props) {
  return props.theme.devices.tablet;
}, function (props) {
  return props.collapsed && styled.css(["flex-basis:50px;", "{width:50px;a{padding-left:15px;}}.collapse{display:none;}footer{padding:5px;}"], SidebarInner);
}, function (props) {
  return props.fixed && styled.css(["margin:auto;", "{position:fixed;height:100%;}", " footer{position:absolute;bottom:0;width:100%;background:none;padding:15px 20px;}"], SidebarInner, SidebarInner);
});

function Sidebar(_ref) {
  var fixed = _ref.fixed,
      collapsed = _ref.collapsed,
      children = _ref.children;
  return /*#__PURE__*/React__namespace.createElement(StyledSidebar, {
    fixed: fixed,
    collapsed: collapsed
  }, /*#__PURE__*/React__namespace.createElement(SidebarInner, null, children));
}

var SSkeletonPulse = styled__default["default"].div.withConfig({
  displayName: "Skeleton__SSkeletonPulse",
  componentId: "sc-1h5k4hx-0"
})(["display:", ";width:100%;margin-right:5px;background:", ";background-size:400% 400%;animation:pulse 2s ease-in-out infinite;@keyframes pulse{0%{background-position:0% 0%;}100%{background-position:-135% 0%;}}&::before{content:\"\\00a0\";}"], function (props) {
  if (props.block) return '1rem';
  return 'inline-block';
}, function (props) {
  return props.translucent ? styled.css(["linear-gradient(-90deg,rgba(255,255,255,0.4) 0%,rgba(255,255,255,0.9) 50%,rgba(255,255,255,0.4) 100%)"]) : styled.css(["linear-gradient(-90deg,rgba(240,240,240,1) 0%,rgba(248,248,248,1) 50%,rgba(240,240,240,1) 100%)"]);
});
var SSkeletonLine = styled__default["default"](SSkeletonPulse).withConfig({
  displayName: "Skeleton__SSkeletonLine",
  componentId: "sc-1h5k4hx-1"
})(["width:5em;border-radius:5px;"]);
var SSkeletonCircle = styled__default["default"](SSkeletonPulse).withConfig({
  displayName: "Skeleton__SSkeletonCircle",
  componentId: "sc-1h5k4hx-2"
})(["width:5em;height:5em;border-radius:50%;"]);

function Skeleton(props) {
  if (props.type === 'circle') {
    return /*#__PURE__*/React__default["default"].createElement(SSkeletonCircle, props);
  } else {
    return /*#__PURE__*/React__default["default"].createElement(SSkeletonLine, props);
  }
}

var GlobalStyle = styled.createGlobalStyle(["html{font-size:", ";}body{padding:0;margin:0;display:flex;flex-direction:column;min-height:100vh;}*,*:before,*:after{box-sizing:border-box;position:relative;}"], function (props) {
  return props.theme.fontSizes.base;
});

var fontFamily$2 = "'Helvetica Neue', Arial, Helvetica, sans-serif";
var fontFamilyHeading$2 = "'Helvetica Neue', Arial, Helvetica, sans-serif";
var fontSizes$2 = {
  base: '14px'
};
var colors$2 = {
  textPrimary: '#222',
  primary: '#222',
  primaryDark: '#111',
  primaryDarker: '#091523',
  tertiary: '#3A8AE8',
  linkColor: '#3A8AE8',
  secondary: 'grey',
  active: '#3A8AE8',
  background: '#F4F6F9',
  danger: '#F03931',
  success: '#2ACC75',
  warning: '#FFB800',
  colorBase: '#FFF',
  grayBase: '#000',
  grayDarkest: '#091523',
  grayDarker: '#444',
  grayDark: '#666',
  grayLight: '#AAA',
  grayLighter: '#E0E6EE',
  grayLightest: '#EEE',
  bgBtnDefault: '#E0E6EE',
  bgBtnLight: '#E3EDFA',
  bgBtnDark: '#091523',
  bgBtnSecondary: '#007474',
  bgBtnTertiary: '#005174',
  bgSidebar: '#0B1A2C'
};
var breakpoints$2 = {
  xs: '320px',
  sm: '425px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1400px'
};
var devices$2 = {
  mobile: "(min-width: ".concat(breakpoints$2.xs, ")"),
  mobileL: "(min-width: ".concat(breakpoints$2.sm, ")"),
  tablet: "(min-width: ".concat(breakpoints$2.md, ")"),
  laptop: "(min-width: ".concat(breakpoints$2.lg, ")"),
  desktop: "(min-width: ".concat(breakpoints$2.xl, ")"),
  desktopL: "(min-width: ".concat(breakpoints$2.xxl, ")")
};
var theme$2 = {
  breakpoints: breakpoints$2,
  colors: colors$2,
  devices: devices$2,
  fontFamily: fontFamily$2,
  fontFamilyHeading: fontFamilyHeading$2,
  fontSizes: fontSizes$2,
  borderRadius: '3px',
  sectionGutter: '100px',
  containerGutter: '1.5rem',
  headingsLineHeight: '1.2',
  headingsMarginTop: '3rem',
  headingsMarginBottom: '0',
  fontSizeH1: '2.3rem',
  fontSizeH2: '1.8rem',
  fontSizeH1Sm: '1.6rem',
  fontSizeH2Sm: '1.4rem',
  fontSizeH3Sm: '1.2rem',
  fontSizeH4Sm: '1.1rem',
  tableHeadFontWeight: 'bold',
  tableHeadCase: 'uppercase'
};

function StyleProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(styled.ThemeProvider, {
    theme: theme || theme$2
  }, /*#__PURE__*/React__default["default"].createElement(reactHelmet.Helmet, null, /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=Noto Sans"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=Lato"
  }), /*#__PURE__*/React__default["default"].createElement("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=Roboto"
  })), /*#__PURE__*/React__default["default"].createElement(GlobalStyle, null), children));
}

var Cell = styled__default["default"].td.withConfig({
  displayName: "Cell",
  componentId: "sc-m05eh0-0"
})(["padding:", ";border-bottom:1px solid #F4F6F9;vertical-align:middle;width:", ";background-color:", ";@media ", "{flex-basis:auto;display:block;}@media ", "{display:table-cell;}"], function (props) {
  return props.compact ? '5px' : '15px';
}, function (props) {
  return props.selectCell ? '1em' : 'auto';
}, function (props) {
  if (props.archived && !props.selected) {
    return props.theme.colors.disabledRow;
  } else if (props.selected) {
    return props.theme.colors.selectedRow;
  }

  return 'inherit';
}, function (props) {
  return props.theme.devices.mobile;
}, function (props) {
  return props.theme.devices.tablet;
});

var CellHeader = styled__default["default"].th.withConfig({
  displayName: "CellHeader",
  componentId: "sc-13pfkiw-0"
})(["padding:20px 15px;text-transform:", ";border-bottom:1px solid #E5E5E5;white-space:nowrap;&.sortable:hover{cursor:pointer;color:", ";}@media ", "{flex-basis:auto;display:block;}@media ", "{display:table-cell;}"], function (props) {
  return props.theme.tableHeadCase || 'none';
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.devices.mobile;
}, function (props) {
  return props.theme.devices.tablet;
});

var DataTable = styled__default["default"].table.withConfig({
  displayName: "Table__DataTable",
  componentId: "sc-1r3sybk-0"
})(["margin-top:10px;text-align:left;color:", ";font-family:", ";font-size:1rem;line-height:160%;background:#fff;border-radius:", ";padding:0px;width:", ";border-collapse:collapse;caption{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;}tbody tr{height:2em;}tbody tr:hover{background-color:#F9F9F9;}thead{th{font-weight:", ";color:", ";svg{position:absolute;transition:transform .4s;}&.sorted{color:", ";svg{color:", ";}}}}"], function (props) {
  return props.theme.colors.textPrimary;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.tableWidth || 'fit-content';
}, function (props) {
  return props.theme.tableHeadFontWeight || 'normal';
}, function (props) {
  return props.theme.colors.tableHeadFontColor || props.theme.colors.textPrimary;
}, function (props) {
  return props.theme.colors.textPrimary;
}, function (props) {
  return props.theme.colors.active;
});

var Table = function Table(props) {
  var headers = props.headers,
      rows = props.rows,
      title = props.title,
      archivedRowKey = props.archivedRowKey;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      selectAll = _useState4[0],
      setSelectAll = _useState4[1];

  React.useEffect(function () {
    if (props.selectAll) {
      props.callBackSelected(selectAllRows({}));
    } else {
      setSelectedRows({});
      setSelectAll(false);

      if (props !== null && props !== void 0 && props.callBackSelected) {
        props === null || props === void 0 ? void 0 : props.callBackSelected({});
      }
    }
  }, [props.selectAll]);

  var renderHeadingRow = function renderHeadingRow(_cell, cellIndex) {
    var headers = props.headers;
    var sortedIcon = '';
    var isSorted = '';
    var isSortable = headers[cellIndex].sortable !== false;
    var rotate = null;

    if (props.sorted === cellIndex && isSortable) {
      isSorted = 'sorted';

      if (props.sort === 'desc') {
        rotate = 180;
      }

      sortedIcon = /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faSortDown,
        fixedWidth: true,
        rotation: rotate
      });
    }

    return /*#__PURE__*/React__default["default"].createElement(CellHeader, {
      key: "heading-".concat(cellIndex),
      className: "".concat(isSorted, " ").concat(isSortable ? 'sortable' : ''),
      onClick: isSortable ? props.callbackSort(cellIndex) : ''
    }, headers[cellIndex].name, sortedIcon);
  };

  var selectAllRows = function selectAllRows(selectAllRowsObj) {
    rows.forEach(function (row, index) {
      selectAllRowsObj[index] = row;
    });
    setSelectAll(true);
    setSelectedRows(_objectSpread2({}, selectAllRowsObj));
    return selectAllRowsObj;
  };

  var selectCell = function selectCell(currentRow, rowIndex, archived) {
    return /*#__PURE__*/React__default["default"].createElement(Cell, {
      key: "select-".concat(rowIndex),
      archived: archived,
      selected: selectedRows[rowIndex],
      compact: props.compact,
      selectCell: true
    }, /*#__PURE__*/React__default["default"].createElement(Checkbox, {
      id: "select-".concat(rowIndex),
      label: '',
      checked: selectedRows[rowIndex],
      inlineTable: true,
      onChange: function onChange(event) {
        var newSelectedRows = selectedRows;

        if (event.target.checked) {
          newSelectedRows = _objectSpread2(_objectSpread2({}, newSelectedRows), {}, _defineProperty({}, rowIndex, currentRow));
          setSelectedRows(_objectSpread2({}, newSelectedRows));
        } else {
          delete newSelectedRows[rowIndex];
          setSelectedRows(_objectSpread2({}, newSelectedRows));
        }

        props.callBackSelected(newSelectedRows);
      }
    }));
  };

  var SelectAllHeading = function SelectAllHeading() {
    return /*#__PURE__*/React__default["default"].createElement(CellHeader, {
      selectAll: true
    }, /*#__PURE__*/React__default["default"].createElement(Checkbox, {
      id: 'select-all',
      label: 'Select all',
      checked: selectAll,
      inlineTableHeading: true,
      onChange: function onChange(event) {
        var selectAllRowsObj = {};

        if (event.target.checked) {
          selectAllRowsObj = selectAllRows(selectAllRowsObj);
        } else {
          setSelectAll(false);
          setSelectedRows(selectAllRowsObj);
        }

        props.callBackSelected(selectAllRowsObj);
      }
    }));
  };

  var renderRow = function renderRow(_row, rowIndex) {
    return /*#__PURE__*/React__default["default"].createElement("tr", {
      key: "row-".concat(rowIndex)
    }, props.selectableRow && selectCell(_row, rowIndex, _row[archivedRowKey]), props.headers.map(function (_cell, cellIndex) {
      return /*#__PURE__*/React__default["default"].createElement(Cell, {
        selected: selectedRows[rowIndex],
        archived: _row[archivedRowKey],
        key: "".concat(rowIndex, "-").concat(cellIndex),
        compact: props.compact
      }, _row[_cell.key]);
    }));
  };

  var tbodyMarkup = rows.map(renderRow);
  var theadMarkup = headers.map(renderHeadingRow);
  return /*#__PURE__*/React__default["default"].createElement(DataTable, null, /*#__PURE__*/React__default["default"].createElement("caption", null, title), /*#__PURE__*/React__default["default"].createElement("caption", null, archivedRowKey), /*#__PURE__*/React__default["default"].createElement("thead", null, /*#__PURE__*/React__default["default"].createElement("tr", null, props.selectableRow && SelectAllHeading(), theadMarkup)), /*#__PURE__*/React__default["default"].createElement("tbody", null, tbodyMarkup));
};

Table.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  selectableRow: PropTypes.bool,
  callbackSort: PropTypes.func,
  title: PropTypes.string,
  sorted: PropTypes.number,
  sort: PropTypes.string,
  callBackSelected: PropTypes.func,
  selectAll: PropTypes.bool,
  compact: PropTypes.bool
};

var Textarea = styled__default["default"].textarea.withConfig({
  displayName: "Textarea",
  componentId: "sc-69favf-0"
})(["font-family:", ";font-size:1rem;background-color:#F9F9F9;border-radius:", ";border:1px solid #F9F9F9;margin:10px 0;padding:10px 20px;width:100%;transition:all .2s,height 0s,width 0s;&:hover{border:1px solid ", ";}&:focus{border:1px solid ", ";box-shadow:0 0 0 2px ", ";}"], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return polished.transparentize(0.7, props.theme.colors.active);
});

function BaseTitle(_ref) {
  var className = _ref.className,
      level = _ref.level,
      id = _ref.id,
      children = _ref.children,
      colour = _ref.colour;
  var HeadingLevel = "h".concat(level);
  return /*#__PURE__*/React__namespace.createElement(HeadingLevel, {
    id: id,
    className: className,
    colour: colour
  }, children);
}

var Title = styled__default["default"](BaseTitle).withConfig({
  displayName: "Title",
  componentId: "sc-1rbng3h-0"
})(["color:", ";font-family:", ";font-size:", ";text-align:", ";display:block;margin:10px 0;padding:", ";margin-top:", ";margin-bottom:", ";line-height:", ";@media only screen and (max-width:", "){font-size:", ";}"], function (props) {
  return props.colour || props.theme.colors.primaryDark;
}, function (props) {
  return props.theme.fontFamilyHeading;
}, function (props) {
  if (props.level === 1) return props.theme.fontSizeH1;
  if (props.level === 2) return props.theme.fontSizeH2;
  if (props.level === 3) return '1.5rem';
  if (props.level === 4) return '1.2rem';
  if (props.level === 5) return '1rem';
  return '2px';
}, function (props) {
  return props.align || 'left';
}, function (props) {
  return props.padding || '0';
}, function (props) {
  return props.marginTop || props.theme.headingsMarginTop;
}, function (props) {
  return props.marginBottom || props.theme.headingsMarginBottom;
}, function (props) {
  return props.theme.headingsLineHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.xl;
}, function (props) {
  if (props.level === 1) return props.theme.fontSizeH1Sm;
  if (props.level === 2) return props.theme.fontSizeH2Sm;
  if (props.level === 3) return props.theme.fontSizeH3Sm;
  if (props.level === 4) return props.theme.fontSizeH4Sm;
  if (props.level === 5) return '1rem';
  return '2px';
});
Title.defaultProps = {
  level: 1
};

var Wrapper = styled__default["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1mtnp1a-0"
})(["display:block;padding:", ";margin:", ";"], function (props) {
  return props.padding || '0';
}, function (props) {
  return props.margin || '0';
});

var AvatarIconWithStatus = styled__default["default"].div.withConfig({
  displayName: "AvatarIconWithStatus",
  componentId: "sc-17ekg6n-0"
})(["border-radius:50%;width:", ";height:", ";margin:10px 10px 10px 0;background-color:#fff;"], function (props) {
  if (props.md) return '3.5em';
  if (props.lg) return '4.5em';
  if (props.xl) return '5.5em';
  return '2.5em';
}, function (props) {
  if (props.md) return '3.5em';
  if (props.lg) return '4.5em';
  if (props.xl) return '5.5em';
  return '2.5em';
});
var AvatarIconWithStatusWrapper = styled__default["default"](AvatarIconWithStatus).withConfig({
  displayName: "AvatarIconWithStatus__AvatarIconWithStatusWrapper",
  componentId: "sc-17ekg6n-1"
})(["position:relative;background-color:", ";"], function (props) {
  return props.backgroundColour ? props.backgroundColour : '#fff';
});
var AvatarIconWithStatusContent = styled__default["default"].div.withConfig({
  displayName: "AvatarIconWithStatus__AvatarIconWithStatusContent",
  componentId: "sc-17ekg6n-2"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]);
var StatusIndicator = styled__default["default"].div.attrs({
  className: 'status-indicator'
}).withConfig({
  displayName: "AvatarIconWithStatus__StatusIndicator",
  componentId: "sc-17ekg6n-3"
})(["right:", ";top:-5px;border-radius:50%;width:", ";height:", ";background-color:", ";position:absolute;"], function (props) {
  if (props.md) return '-8px';
  if (props.lg) return '-6px';
  if (props.xl) return '-4px';
  return '-10px';
}, function (props) {
  if (props.md) return '1.75em';
  if (props.lg) return '2.0em';
  if (props.xl) return '2.25em';
  return '1.5em';
}, function (props) {
  if (props.md) return '1.75em';
  if (props.lg) return '2.0em';
  if (props.xl) return '2.25em';
  return '1.5em';
}, function (props) {
  return props.backgroundColour ? props.backgroundColour : '#fff';
});
var SuccessStatus = styled__default["default"](StatusIndicator).withConfig({
  displayName: "AvatarIconWithStatus__SuccessStatus",
  componentId: "sc-17ekg6n-4"
})(["background-color:", ";color:#fff;text-align:center;padding:", ";"], function (props) {
  return props.theme.successStatusColour;
}, function (props) {
  if (props.md) return '0.35em';
  if (props.lg) return '0.45em';
  if (props.xl) return '0.55em';
  return '0.2em';
});
var WarningStatus = styled__default["default"](StatusIndicator).withConfig({
  displayName: "AvatarIconWithStatus__WarningStatus",
  componentId: "sc-17ekg6n-5"
})(["background-color:", ";text-align:center;padding:", ";"], function (props) {
  return props.theme.warningStatusColour;
}, function (props) {
  if (props.md) return '0.35em';
  if (props.lg) return '0.35em';
  if (props.xl) return '0.5em';
  return '0.1em';
});
var ErrorStatus = styled__default["default"](StatusIndicator).withConfig({
  displayName: "AvatarIconWithStatus__ErrorStatus",
  componentId: "sc-17ekg6n-6"
})(["background-color:", ";color:#fff;text-align:center;padding:", ";"], function (props) {
  return props.theme.errorStatusColour;
}, function (props) {
  if (props.md) return '0.35em';
  if (props.lg) return '0.35em';
  if (props.xl) return '0.5em';
  return '0.1em';
});

var AccordionWrapper = styled__default["default"].div.withConfig({
  displayName: "Accordion__AccordionWrapper",
  componentId: "sc-oqf40-0"
})(["padding:", ";font-size:1.4em;font-family:", ";"], function (props) {
  return props.padding ? props.padding : props.theme.accordionSpacing;
}, function (props) {
  return props.theme.fontFamilyHeading;
});
var AccordionHeader = styled__default["default"].div.withConfig({
  displayName: "Accordion__AccordionHeader",
  componentId: "sc-oqf40-1"
})(["display:flex;justify-content:space-between;align-items:center;height:3.3em;padding:10px;background-color:", ";border-radius:", ";"], function (props) {
  return props.theme.accordionBackgroundColour;
}, function (props) {
  return props.borderRadius ? props.borderRadius : props.theme.borderRadius;
});
var AccordionHeading = styled__default["default"].h3.withConfig({
  displayName: "Accordion__AccordionHeading",
  componentId: "sc-oqf40-2"
})(["color:", ";margin:0 5px;"], function (props) {
  return props.theme.accordionTextColour;
});
var AccordionHeadingSection = styled__default["default"].div.withConfig({
  displayName: "Accordion__AccordionHeadingSection",
  componentId: "sc-oqf40-3"
})(["display:flex;align-items:center;"]);
var AccordionControl = styled__default["default"].button.withConfig({
  displayName: "Accordion__AccordionControl",
  componentId: "sc-oqf40-4"
})(["text-align:center;border:0;color:", ";background-color:", ";font-size:1.4em;:hover{cursor:pointer;}"], function (props) {
  return props.theme.accordionTextColour;
}, function (props) {
  return props.theme.accordionBackgroundColour;
});

var AccordionAvatarWrapper = function AccordionAvatarWrapper(_ref) {
  var status = _ref.status,
      icon = _ref.icon;

  switch (status) {
    case 'success':
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusWrapper, {
        status: status
      }, /*#__PURE__*/React__default["default"].createElement(SuccessStatus, null, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faCheck
      })), /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusContent, null, icon || /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faList
      }))));

    case 'warning':
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusWrapper, null, /*#__PURE__*/React__default["default"].createElement(WarningStatus, null, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faExclamation
      })), /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusContent, null, icon || /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faList
      }))));

    case 'error':
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusWrapper, null, /*#__PURE__*/React__default["default"].createElement(ErrorStatus, null, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faTimes
      })), /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusContent, null, icon || /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faList
      }))));

    default:
      return /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusWrapper, null, /*#__PURE__*/React__default["default"].createElement(AvatarIconWithStatusContent, null, icon || /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: freeSolidSvgIcons.faList
      })));
  }
};

var AccordionBody = styled__default["default"].div.withConfig({
  displayName: "Accordion__AccordionBody",
  componentId: "sc-oqf40-5"
})(["background-color:#FFF;padding:10px 20px 20px;"]);
var AccordionHelpPopup = styled__default["default"].div.withConfig({
  displayName: "Accordion__AccordionHelpPopup",
  componentId: "sc-oqf40-6"
})(["position:absolute;z-index:2;background-color:", ";padding:5px;min-width:8em;font-size:14px;"], function (props) {
  return props.theme.colors.grayDarker;
});

function Accordion(_ref2) {
  var status = _ref2.status,
      children = _ref2.children,
      icon = _ref2.icon,
      heading = _ref2.heading,
      help = _ref2.help,
      open = _ref2.open,
      _ref2$defaultOpen = _ref2.defaultOpen,
      defaultOpen = _ref2$defaultOpen === void 0 ? false : _ref2$defaultOpen,
      innerRef = _ref2.innerRef,
      padding = _ref2.padding,
      borderRadius = _ref2.borderRadius,
      scrollIntoViewOnOpen = _ref2.scrollIntoViewOnOpen,
      helpText = _ref2.helpText;

  var _useState = React.useState(defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showHelp = _useState4[0],
      setShowHelp = _useState4[1];

  var iconUpElement = /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faChevronUp,
    fixedWidth: true
  });
  var iconDownElement = /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faChevronDown,
    fixedWidth: true
  });
  var accordionId = "accordion_".concat(heading, "_").concat(Math.random());
  React.useEffect(function () {
    !expanded && setExpanded(open);
  }, [open]);
  /**
   * When the accordion is expanded have it scroll into view
   */

  React.useEffect(function () {
    if (expanded === open && scrollIntoViewOnOpen) {
      innerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }, [expanded]);
  return /*#__PURE__*/React__default["default"].createElement(AccordionWrapper, {
    ref: innerRef,
    padding: padding,
    onMouseOut: function onMouseOut() {
      setShowHelp(false);
    }
  }, /*#__PURE__*/React__default["default"].createElement(AccordionHeader, {
    borderRadius: borderRadius
  }, /*#__PURE__*/React__default["default"].createElement(AccordionHeadingSection, null, /*#__PURE__*/React__default["default"].createElement(AccordionAvatarWrapper, {
    status: status,
    icon: icon
  }), /*#__PURE__*/React__default["default"].createElement(AccordionHeading, null, heading), help && /*#__PURE__*/React__default["default"].createElement(AccordionControl, {
    onClick: function onClick(evt) {
      evt.preventDefault();
      setShowHelp(!showHelp);
    }
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faInfoCircle
  }), showHelp && /*#__PURE__*/React__default["default"].createElement(AccordionHelpPopup, null, helpText))), /*#__PURE__*/React__default["default"].createElement(AccordionControl, {
    id: accordionId,
    onClick: function onClick(evt) {
      evt.preventDefault();

      if (document.activeElement.id === accordionId) {
        setExpanded(!expanded);
      }
    }
  }, expanded ? iconUpElement : iconDownElement)), expanded && /*#__PURE__*/React__default["default"].createElement(AccordionBody, null, children));
}

var QuickAccessToolbarContainer = styled__default["default"].div.withConfig({
  displayName: "QuickAccessToolbar__QuickAccessToolbarContainer",
  componentId: "sc-jpl114-0"
})(["display:flex;flex-direction:column;height:100%;padding:5px;transition:160ms all;width:", ";background-color:#8C9BAD;"], function (props) {
  return props.expanded ? '100%' : '60px';
});
var QuickAccessToolbarContent = styled__default["default"].div.withConfig({
  displayName: "QuickAccessToolbar__QuickAccessToolbarContent",
  componentId: "sc-jpl114-1"
})(["border-bottom:2px solid white;"]);
var QuickAccessToolbarButton = styled__default["default"].button.withConfig({
  displayName: "QuickAccessToolbar__QuickAccessToolbarButton",
  componentId: "sc-jpl114-2"
})(["border:none;background:none;display:flex;flex-direction:row;align-items:center;transition:160ms all;h3:{margin-left:10px}:hover{cursor:pointer;}"]);
var QuickAccessToolbarControlSection = styled__default["default"].div.withConfig({
  displayName: "QuickAccessToolbar__QuickAccessToolbarControlSection",
  componentId: "sc-jpl114-3"
})(["display:flex;flex-direction:row;transition:160ms all;margin-top:5px;justify-content:", ";:hover{cursor:pointer;}"], function (props) {
  return props.expanded ? 'flex-end' : 'center';
});
var QuickAccessToolbarControl = styled__default["default"].button.withConfig({
  displayName: "QuickAccessToolbar__QuickAccessToolbarControl",
  componentId: "sc-jpl114-4"
})(["border:none;border-radius:5px;color:#fff;background:none;:hover{cursor:pointer;}"]);
var QuickAccessToolbarTitle = styled__default["default"](Title).withConfig({
  displayName: "QuickAccessToolbar__QuickAccessToolbarTitle",
  componentId: "sc-jpl114-5"
})(["color:#fff;"]);

function QuickAccessToolbar(_ref) {
  var buttonList = _ref.buttonList,
      expandedCallback = _ref.expandedCallback,
      clickedOptionCallback = _ref.clickedOptionCallback;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expand = _useState2[0],
      setExpanded = _useState2[1];

  return /*#__PURE__*/React__default["default"].createElement(QuickAccessToolbarContainer, {
    expanded: expand
  }, /*#__PURE__*/React__default["default"].createElement(QuickAccessToolbarContent, null, buttonList.map(function (button, index) {
    return /*#__PURE__*/React__default["default"].createElement(QuickAccessToolbarButton, {
      key: "".concat(index, "_").concat(button.name),
      title: "Jump to ".concat(button.name),
      onClick: function onClick() {
        clickedOptionCallback === null || clickedOptionCallback === void 0 ? void 0 : clickedOptionCallback(button.name);
        button.ref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    }, button.element, expand && /*#__PURE__*/React__default["default"].createElement(QuickAccessToolbarTitle, {
      level: 3,
      marginTop: "0"
    }, button.name));
  })), /*#__PURE__*/React__default["default"].createElement(QuickAccessToolbarControlSection, {
    expanded: expand,
    onClick: function onClick() {
      expandedCallback(!expand);
      setExpanded(!expand);
    }
  }, /*#__PURE__*/React__default["default"].createElement(QuickAccessToolbarControl, {
    title: "".concat(expand ? 'Collapse' : 'Expand', " quick access toolbar")
  }, !expand ? /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faArrowRight
  }) : /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faArrowLeft
  }))));
}

var _excluded$1 = ["label", "handleChange", "checked", "padding", "disabled", "offColor"];
var ToggleLabelContainer = styled__default["default"].label.withConfig({
  displayName: "Toggle__ToggleLabelContainer",
  componentId: "sc-1d544h-0"
})(["display:flex;flex-direction:row;align-items:center;padding:", ";"], function (props) {
  return props.padding || '1em';
});
var ToggleText = styled__default["default"](Text).withConfig({
  displayName: "Toggle__ToggleText",
  componentId: "sc-1d544h-1"
})(["margin:5px;font-size:1.3em;"]);

function Toggle(_ref) {
  var label = _ref.label,
      handleChange = _ref.handleChange,
      checked = _ref.checked,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? false : _ref$padding,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$offColor = _ref.offColor,
      offColor = _ref$offColor === void 0 ? null : _ref$offColor,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var theme = styled.useTheme();
  offColor = offColor || theme.toggleOffColor;
  return /*#__PURE__*/React__default["default"].createElement(ToggleLabelContainer, {
    padding: padding
  }, /*#__PURE__*/React__default["default"].createElement(ToggleText, null, label), /*#__PURE__*/React__default["default"].createElement(Switch__default["default"], _extends$2({
    onChange: handleChange,
    checked: checked,
    disabled: disabled,
    handleDiameter: 20,
    offHandleColor: "#8C9BAD",
    onColor: "#3A8AE8",
    offColor: offColor,
    uncheckedIcon: false,
    checkedIcon: false
  }, rest)));
}

var DialogWrapper = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogWrapper",
  componentId: "sc-1grzbqt-0"
})(["background-color:rgb(0 0 0 / 25%);z-index:4;height:100vh;width:100%;position:absolute;display:flex;justify-content:center;align-items:center;font-family:", ";"], function (props) {
  return props.theme.fontFamilyHeading;
});
var DialogContainer = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogContainer",
  componentId: "sc-1grzbqt-1"
})(["background-color:#fff;min-width:20%;min-height:20%;border-radius:3px;box-shadow:0 3px 6px 3px rgb(0 0 0 / 15%);display:flex;flex-direction:column;justify-content:space-between;text-align:left;"]);
var DialogHeader = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogHeader",
  componentId: "sc-1grzbqt-2"
})(["background-color:", ";padding:1em;border-bottom:3px solid ", ";font-size:1.4em;color:white;display:flex;flex-direction:row;align-items:center;justify-content:space-between;"], function (props) {
  return props.theme.dialogHeaderBackgroundColour;
}, function (props) {
  return props.theme.dialogHeaderHighlightColour;
});
var DialogHeaderTitle = styled__default["default"].h4.withConfig({
  displayName: "Dialog__DialogHeaderTitle",
  componentId: "sc-1grzbqt-3"
})(["font-size:1.4em;font-weight:bold;margin:0;"]);
var DialogHeaderCloseButtonContainer = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogHeaderCloseButtonContainer",
  componentId: "sc-1grzbqt-4"
})(["padding:5px;"]);
var DialogCloseButton = styled__default["default"].button.withConfig({
  displayName: "Dialog__DialogCloseButton",
  componentId: "sc-1grzbqt-5"
})(["border:0;background:none;color:#fff;padding:0;font-size:1em;cursor:pointer;&:hover{background-color:rgb(255 255 255 / 22%);border-radius:50%;}"]);
var DialogContentContainer = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogContentContainer",
  componentId: "sc-1grzbqt-6"
})(["padding:1em;display:flex;flex:3;"]);
var DialogContent = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogContent",
  componentId: "sc-1grzbqt-7"
})(["height:100%;"]);
var DialogControlBar = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogControlBar",
  componentId: "sc-1grzbqt-8"
})(["display:flex;flex-direction:row;justify-content:flex-end;align-items:center;background-color:", ";padding:1em;"], function (props) {
  return props.theme.colors.accentColor;
});
var DialogControlButtons = styled__default["default"].button.withConfig({
  displayName: "Dialog__DialogControlButtons",
  componentId: "sc-1grzbqt-9"
})(["font-weight:bold;border:none;background-color:", ";color:#fff;padding:5px;border-radius:3px;cursor:pointer;&:hover{opacity:0.8;}&:not(:last-of-type){margin-right:5px;}"], function (props) {
  return props.confirm ? props.theme.dialogConfirmColour : props.theme.colors.active;
});
var DialogConfirmButtonGroup = styled__default["default"].div.withConfig({
  displayName: "Dialog__DialogConfirmButtonGroup",
  componentId: "sc-1grzbqt-10"
})(["display:flex;width:100%;justify-content:flex-end;"]);

function Dialog(_ref) {
  var title = _ref.title,
      message = _ref.message,
      onDismiss = _ref.onDismiss,
      onConfirm = _ref.onConfirm,
      type = _ref.type;
  var iconClosElement = /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: freeSolidSvgIcons.faTimes,
    fixedWidth: true
  });

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var RenderControls = function RenderControls() {
    if (type && (type === 'confirm' || type === 'input')) {
      return /*#__PURE__*/React__default["default"].createElement(DialogConfirmButtonGroup, null, /*#__PURE__*/React__default["default"].createElement(DialogControlButtons, {
        onClick: function onClick() {
          if (type === 'input') {
            onConfirm(value);
            return;
          }

          onConfirm();
        },
        confirm: true
      }, "OK"), /*#__PURE__*/React__default["default"].createElement(DialogControlButtons, {
        onClick: onDismiss
      }, "Cancel"));
    } else {
      return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(DialogControlButtons, {
        onClick: onDismiss
      }, "Okay"));
    }
  };

  var dismissOutsideContent = function dismissOutsideContent(event) {
    event.preventDefault();
    var clickedElement = event.target.getAttribute('name');
    clickedElement === 'wrapper' && onDismiss();
  };

  return /*#__PURE__*/React__default["default"].createElement(DialogWrapper, {
    onClick: dismissOutsideContent,
    name: "wrapper"
  }, /*#__PURE__*/React__default["default"].createElement(DialogContainer, {
    onClick: dismissOutsideContent
  }, /*#__PURE__*/React__default["default"].createElement(DialogHeader, null, /*#__PURE__*/React__default["default"].createElement(DialogHeaderTitle, null, title), /*#__PURE__*/React__default["default"].createElement(DialogHeaderCloseButtonContainer, null, /*#__PURE__*/React__default["default"].createElement(DialogCloseButton, {
    onClick: onDismiss
  }, iconClosElement))), /*#__PURE__*/React__default["default"].createElement(DialogContentContainer, null, /*#__PURE__*/React__default["default"].createElement(DialogContent, null, message, type === 'input' && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement(Input, {
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    }
  })))), /*#__PURE__*/React__default["default"].createElement(DialogControlBar, null, RenderControls())));
}

var MenuContainer = styled__default["default"].div.withConfig({
  displayName: "PopoutMenu__MenuContainer",
  componentId: "sc-1hidcvf-0"
})(["position:relative;padding:5px;font-family:", ";font-size:", ";"], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSizes.base;
});
var MenuButton = styled__default["default"].button.withConfig({
  displayName: "PopoutMenu__MenuButton",
  componentId: "sc-1hidcvf-1"
})(["border:none;background:", ";color:", ";padding:10px;border-radius:3px;cursor:pointer;width:100%;:hover{background:", ";}"], function (props) {
  return props.buttonBackgroundColour || props.theme.popoutMenuButtonColour;
}, function (props) {
  return props.buttonTextColour || '#fff';
}, function (props) {
  return props.buttonBackgroundHoverColour || props.theme.popoutMenuHoverButtonColour;
});
var PopoutMenuItem = styled__default["default"].button.withConfig({
  displayName: "PopoutMenu__PopoutMenuItem",
  componentId: "sc-1hidcvf-2"
})(["padding:10px;background-color:#f4f6f9;border:none;cursor:pointer;display:flex;flex-direction:row;justify-content:space-evenly;align-items:center;width:100%;:hover{background-color:#c7c7c7;}"]);
var PopoutMenuList = styled__default["default"].ul.withConfig({
  displayName: "PopoutMenu__PopoutMenuList",
  componentId: "sc-1hidcvf-3"
})(["position:absolute;list-style:none;padding:0;min-width:100px;background:", ";box-shadow:2px 2px 2px 0 rgba(0,0,0,0.25);z-index:2;border-radius:3px;text-align:center;top:2.5em;left:1em;"], function (props) {
  return props.theme.colors.background;
});

function PopoutMenu(_ref) {
  var label = _ref.label,
      menuItems = _ref.menuItems,
      buttonBackgroundColour = _ref.buttonBackgroundColour,
      buttonBackgroundHoverColour = _ref.buttonBackgroundHoverColour,
      buttonTextColour = _ref.buttonTextColour;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMenu = _useState2[0],
      setShowMenu = _useState2[1];

  return /*#__PURE__*/React__default["default"].createElement(MenuContainer, {
    onMouseLeave: function onMouseLeave() {
      return setShowMenu(false);
    }
  }, /*#__PURE__*/React__default["default"].createElement(MenuButton, {
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    },
    buttonBackgroundColour: buttonBackgroundColour,
    buttonBackgroundHoverColour: buttonBackgroundHoverColour,
    buttonTextColour: buttonTextColour
  }, label), showMenu && /*#__PURE__*/React__default["default"].createElement(PopoutMenuList, null, menuItems.map(function (menuItem, index) {
    return /*#__PURE__*/React__default["default"].createElement(PopoutMenuItem, {
      key: "".concat(menuItem.label, "_").concat(index),
      onClick: function onClick() {
        setShowMenu(false);
        menuItem.method();
      },
      disabled: menuItem === null || menuItem === void 0 ? void 0 : menuItem.disabled
    }, (menuItem === null || menuItem === void 0 ? void 0 : menuItem.icon) && /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
      icon: menuItem === null || menuItem === void 0 ? void 0 : menuItem.icon
    }), " ", menuItem.label);
  })));
}

var AnimatedSidebarStyled = styled__default["default"].div.withConfig({
  displayName: "AnimatedSidebar__AnimatedSidebarStyled",
  componentId: "sc-17508qi-0"
})(["min-width:", ";background:", ";padding:10px;color:white;transition:0.4s ease-in;"], function (props) {
  return props.isOpen ? '250px' : '52px';
}, function (props) {
  return props.theme.colors.bgSidebar;
});
var SidebarCollapseContainer = styled__default["default"].div.withConfig({
  displayName: "AnimatedSidebar__SidebarCollapseContainer",
  componentId: "sc-17508qi-1"
})(["", ""], function (props) {
  return !props.isOpen && styled.css(["display:none"]);
});
var ShowCloseButton = styled__default["default"].button.withConfig({
  displayName: "AnimatedSidebar__ShowCloseButton",
  componentId: "sc-17508qi-2"
})(["background:transparent;padding:10px;border:1px solid white;border-radius:4px;color:white;transition:0.3s linear;", ""], function (props) {
  return props.isOpen && styled.css(["float:right;"]);
});
var SidebarIconToggle = function SidebarIconToggle(_ref) {
  var isOpen = _ref.isOpen,
      buttonIcons = _ref.buttonIcons;
  var icon = buttonIcons[isOpen ? 'open' : 'closed'];
  return /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: icon
  });
};
var AnimatedSidebar = function AnimatedSidebar(_ref2) {
  var buttonIcons = _ref2.buttonIcons,
      children = _ref2.children;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  if (!buttonIcons || !buttonIcons.open || !buttonIcons.close) {
    buttonIcons = {
      open: freeSolidSvgIcons.faWindowClose,
      closed: freeSolidSvgIcons.faBars
    };
  }

  return /*#__PURE__*/React__default["default"].createElement(AnimatedSidebarStyled, {
    isOpen: isOpen
  }, /*#__PURE__*/React__default["default"].createElement(ShowCloseButton, {
    isOpen: isOpen,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React__default["default"].createElement(SidebarIconToggle, {
    isOpen: isOpen,
    buttonIcons: buttonIcons
  })), /*#__PURE__*/React__default["default"].createElement(SidebarCollapseContainer, {
    isOpen: isOpen
  }, children));
};

var spinAnimation = styled.keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var growingBarsKeyframe = styled.keyframes(["0%,80%,100%{box-shadow:0 0;height:4em;}40%{box-shadow:0 -2em;height:5em;}"]);
styled.keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var DotsSpinnerKeyframe = styled.keyframes(["0%,100%{box-shadow:0 -3em 0 0.2em,2em -2em 0 0em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 0;}12.5%{box-shadow:0 -3em 0 0,2em -2em 0 0.2em,3em 0 0 0,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em;}25%{box-shadow:0 -3em 0 -0.5em,2em -2em 0 0,3em 0 0 0.2em,2em 2em 0 0,0 3em 0 -1em,-2em 2em 0 -1em,-3em 0 0 -1em,-2em -2em 0 -1em;}37.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0em 0 0,2em 2em 0 0.2em,0 3em 0 0em,-2em 2em 0 -1em,-3em 0em 0 -1em,-2em -2em 0 -1em;}50%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 0em,0 3em 0 0.2em,-2em 2em 0 0,-3em 0em 0 -1em,-2em -2em 0 -1em;}62.5%{box-shadow:0 -3em 0 -1em,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 0,-2em 2em 0 0.2em,-3em 0 0 0,-2em -2em 0 -1em;}75%{box-shadow:0em -3em 0 -1em,2em -2em 0 -1em,3em 0em 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0em 0 0.2em,-2em -2em 0 0;}87.5%{box-shadow:0em -3em 0 0,2em -2em 0 -1em,3em 0 0 -1em,2em 2em 0 -1em,0 3em 0 -1em,-2em 2em 0 0,-3em 0em 0 0,-2em -2em 0 0.2em;}"]);
var GradientDotsKeyframe = function GradientDotsKeyframe(foregroundColor) {
  var full = foregroundColor;
  var twoPercent = foregroundColor + '33';
  var fivePercent = foregroundColor + '80';
  var seventPercent = foregroundColor + 'b3';
  return styled.keyframes(["0%,100%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}12.5%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}25%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}37.5%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}50%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}62.5%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}75%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}87.5%{box-shadow:0em -2.6em 0em 0em ", ",1.8em -1.8em 0 0em ", ",2.5em 0em 0 0em ", ",1.75em 1.75em 0 0em ", ",0em 2.5em 0 0em ", ",-1.8em 1.8em 0 0em ", ",-2.6em 0em 0 0em ", ",-1.8em -1.8em 0 0em ", ";}"], full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, seventPercent, seventPercent, full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, fivePercent, seventPercent, full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, seventPercent, full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, seventPercent, full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, seventPercent, full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, seventPercent, full, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, twoPercent, fivePercent, seventPercent, full);
};
var GrowSpinnerKeyframe = styled.keyframes(["0%{box-shadow:0 -0.83em 0 -0.4em,0 -0.83em 0 -0.42em,0 -0.83em 0 -0.44em,0 -0.83em 0 -0.46em,0 -0.83em 0 -0.477em;}5%,95%{box-shadow:0 -0.83em 0 -0.4em,0 -0.83em 0 -0.42em,0 -0.83em 0 -0.44em,0 -0.83em 0 -0.46em,0 -0.83em 0 -0.477em;}10%,59%{box-shadow:0 -0.83em 0 -0.4em,-0.087em -0.825em 0 -0.42em,-0.173em -0.812em 0 -0.44em,-0.256em -0.789em 0 -0.46em,-0.297em -0.775em 0 -0.477em;}20%{box-shadow:0 -0.83em 0 -0.4em,-0.338em -0.758em 0 -0.42em,-0.555em -0.617em 0 -0.44em,-0.671em -0.488em 0 -0.46em,-0.749em -0.34em 0 -0.477em;}38%{box-shadow:0 -0.83em 0 -0.4em,-0.377em -0.74em 0 -0.42em,-0.645em -0.522em 0 -0.44em,-0.775em -0.297em 0 -0.46em,-0.82em -0.09em 0 -0.477em;}100%{box-shadow:0 -0.83em 0 -0.4em,0 -0.83em 0 -0.42em,0 -0.83em 0 -0.44em,0 -0.83em 0 -0.46em,0 -0.83em 0 -0.477em;}"]);
var GrowingCirclesKeyframe = styled.keyframes(["0%,80%,100%{box-shadow:0 2.5em 0 -1.3em;}40%{box-shadow:0 2.5em 0 0;}"]);

/* stylelint-disable no-duplicate-selectors */
var GrowingBars = styled__default["default"].div.withConfig({
  displayName: "types__GrowingBars",
  componentId: "sc-17pkyaj-0"
})(["&,&:before,&:after{background:", ";animation:", " 1s infinite ease-in-out;width:1em;height:4em;}&{color:", ";text-indent:-9999em;margin:88px auto;position:relative;font-size:", ";transform:translateZ(0);animation-delay:-0.16s;}&:before,&:after{position:absolute;top:0;content:'';}&:before{left:-1.5em;animation-delay:-0.32s;}&:after{left:1.5em;}"], function (props) {
  return props.foregroundColor;
}, growingBarsKeyframe, function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.size ? props.size : '11px';
});
var CircleSpinner = styled__default["default"].div.withConfig({
  displayName: "types__CircleSpinner",
  componentId: "sc-17pkyaj-1"
})(["&,&:before,&:after{border-radius:50%;}&{color:", ";font-size:", ";text-indent:-99999em;margin:55px auto;position:relative;width:10em;height:10em;box-shadow:inset 0 0 0 1em;transform:translateZ(0);}&:before,&:after{position:absolute;content:'';}&:before{width:5.2em;height:10.2em;background:", ";border-radius:10.2em 0 0 10.2em;top:-0.1em;left:-0.1em;transform-origin:5.1em 5.1em;animation:", " 2s infinite ease 1.5s;}&:after{width:5.2em;height:10.2em;background:", ";border-radius:0 10.2em 10.2em 0;top:-0.1em;left:4.9em;transform-origin:0.1em 5.1em;animation:", " 2s infinite ease;}"], function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.size ? props.size : '11px';
}, function (props) {
  return props.backgroundColor;
}, spinAnimation, function (props) {
  return props.backgroundColor;
}, spinAnimation);
var GradientSpinner = styled__default["default"].div.withConfig({
  displayName: "types__GradientSpinner",
  componentId: "sc-17pkyaj-2"
})(["&{font-size:", ";margin:50px auto;text-indent:-9999em;width:11em;height:11em;border-radius:50%;background:", ";background:linear-gradient(to right,", " 10%,rgba(255,255,255,0) 42%);position:relative;animation:", " 1.4s infinite linear;transform:translateZ(0);}&:before{width:50%;height:50%;background:", ";border-radius:100% 0 0 0;position:absolute;top:0;left:0;content:'';}&:after{background:", ";width:75%;height:75%;border-radius:50%;content:'';margin:auto;position:absolute;top:0;left:0;bottom:0;right:0;}"], function (props) {
  return props.size ? props.size : '10px';
}, function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.foregroundColor;
}, spinAnimation, function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.backgroundColor;
});
var DotsSpinner = styled__default["default"].div.withConfig({
  displayName: "types__DotsSpinner",
  componentId: "sc-17pkyaj-3"
})(["&{color:", ";font-size:", ";margin:100px auto;width:1em;height:1em;border-radius:50%;position:relative;text-indent:-9999em;animation:", " 1.3s infinite linear;transform:translateZ(0);}"], function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.size ? props.size : '20px';
}, DotsSpinnerKeyframe);
var GradientDots = styled__default["default"].div.withConfig({
  displayName: "types__GradientDots",
  componentId: "sc-17pkyaj-4"
})(["&{margin:100px auto;font-size:", ";width:1em;height:1em;border-radius:50%;position:relative;text-indent:-9999em;animation:", " 1.1s infinite ease;transform:translateZ(0);}"], function (props) {
  return props.size ? props.size : '25px';
}, function (props) {
  return GradientDotsKeyframe(props.foregroundColor);
});
var GrowSpinner = styled__default["default"].div.withConfig({
  displayName: "types__GrowSpinner",
  componentId: "sc-17pkyaj-5"
})(["color:", ";font-size:", ";text-indent:-9999em;overflow:hidden;width:1em;height:1em;border-radius:50%;margin:72px auto;position:relative;transform:translateZ(0);animation:", " 1.7s infinite ease,", " 1.7s infinite ease;"], function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.size ? props.size : '90px';
}, GrowSpinnerKeyframe, spinAnimation);
var GrowingCircles = styled__default["default"].div.withConfig({
  displayName: "types__GrowingCircles",
  componentId: "sc-17pkyaj-6"
})(["&,&:before,&:after{border-radius:50%;width:2.5em;height:2.5em;animation:", " 1.8s infinite ease-in-out;animation-fill-mode:both;}&{color:", ";font-size:", ";margin:80px auto;position:relative;text-indent:-9999em;transform:translateZ(0);animation-delay:-0.16s;}&:before,&:after{content:'';position:absolute;top:0;}&:before{left:-3.5em;animation-delay:-0.32s;}&:after{left:3.5em;}"], GrowingCirclesKeyframe, function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.size ? props.size : '10px';
});
var SpinnerType8 = styled__default["default"].div.withConfig({
  displayName: "types__SpinnerType8",
  componentId: "sc-17pkyaj-7"
})(["&,&:after{border-radius:50%;width:10em;height:10em;}&{margin:60px auto;font-size:", ";position:relative;text-indent:-9999em;border-top:1.1em solid ", ";border-right:1.1em solid ", ";border-bottom:1.1em solid ", ";border-left:1.1em solid ", ";transform:translateZ(0);animation:", " 1.1s infinite linear;}"], function (props) {
  return props.size ? props.size : '10px';
}, function (props) {
  return props.foregroundColor;
}, function (props) {
  return props.foregroundColor + '33';
}, function (props) {
  return props.foregroundColor + '33';
}, function (props) {
  return props.foregroundColor + '33';
}, spinAnimation);
/* stylelint-enable no-duplicate-selectors */

var _excluded = ["backgroundColor", "foregroundColor", "size"];

var getComponent = function getComponent(type) {
  switch (type) {
    case 'growingBars':
      return GrowingBars;

    case 'circleSpinner':
      return CircleSpinner;

    case 'gradientSpinner':
      return GradientSpinner;

    case 'dotsSpinner':
      return DotsSpinner;

    case 'gradientDots':
      return GradientDots;

    case 'growSpinner':
      return GrowSpinner;

    case 'growingCircles':
      return GrowingCircles;

    case 'circleBackground':
      return SpinnerType8;

    default:
      return GrowingBars;
  }
};

var SpinnerContainer = styled__default["default"].div.withConfig({
  displayName: "Spinner__SpinnerContainer",
  componentId: "sc-1ww8tdt-0"
})(["width:200px;overflow:hidden;height:200px;margin:auto;"]);
var Background = styled__default["default"].div.withConfig({
  displayName: "Spinner__Background",
  componentId: "sc-1ww8tdt-1"
})(["background-color:", ";position:absolute;top:0;left:0;height:100%;width:100%;"], function (props) {
  return props.backgroundColor;
});
var Spinner = styled__default["default"].div.withConfig({
  displayName: "Spinner",
  componentId: "sc-1ww8tdt-2"
})(["min-height:200px;min-width:200px;display:flex;"]);
var SpinnerForground = function SpinnerForground(props) {
  var Component = getComponent(props.type);
  return /*#__PURE__*/React__namespace.createElement(SpinnerContainer, null, /*#__PURE__*/React__namespace.createElement(Component, props));
};
var BaseSpinner = function BaseSpinner(props) {
  var backgroundColor = props.backgroundColor,
      foregroundColor = props.foregroundColor,
      size = props.size,
      rest = _objectWithoutProperties(props, _excluded);

  backgroundColor = backgroundColor || theme$2.colors.background;
  foregroundColor = foregroundColor || theme$2.colors.foreground;
  size = size || '10px';

  var args = _objectSpread2({
    backgroundColor: backgroundColor,
    foregroundColor: foregroundColor,
    size: size
  }, rest);

  return /*#__PURE__*/React__namespace.createElement(Spinner, null, /*#__PURE__*/React__namespace.createElement(Background, args), /*#__PURE__*/React__namespace.createElement(SpinnerForground, args));
};

var fontFamily$1 = "Noto Sans, 'Helvetica Neue', Arial, Helvetica, sans-serif";
var fontFamilyHeading$1 = "Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif";
var fontSizes$1 = {
  base: '12px'
};
var colors$1 = {
  textPrimary: '#222',
  primary: '#222',
  primaryDark: '#111',
  primaryDarker: '#091523',
  tertiary: '#3A8AE8',
  linkColor: '#3A8AE8',
  secondary: 'grey',
  active: '#3A8AE8',
  background: '#F4F6F9',
  danger: '#F03931',
  success: '#2ACC75',
  warning: '#FFB800',
  colorBase: '#FFF',
  grayBase: '#000',
  grayDarkest: '#091523',
  grayDarker: '#444',
  grayDark: '#666',
  grayMedium: '#ccc',
  grayLight: '#AAA',
  grayLighter: '#E0E6EE',
  grayLightest: '#EEE',
  grayEvenLighter: '#f6f6f6',
  bgBtnDefault: '#E0E6EE',
  bgBtnLight: '#E3EDFA',
  bgBtnDark: '#091523',
  bgBtnSecondary: '#007474',
  bgBtnTertiary: '#005174',
  bgSidebar: '#0B1A2C',
  tableHeadFontColor: '#222',
  disabledRow: '#dadada',
  selectedRow: '#b1d5ff',
  accentColor: '#c3c3c3'
};
var breakpoints$1 = {
  xs: '320px',
  sm: '425px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1400px'
};
var devices$1 = {
  mobile: "(min-width: ".concat(breakpoints$1.xs, ")"),
  mobileL: "(min-width: ".concat(breakpoints$1.sm, ")"),
  tablet: "(min-width: ".concat(breakpoints$1.md, ")"),
  laptop: "(min-width: ".concat(breakpoints$1.lg, ")"),
  desktop: "(min-width: ".concat(breakpoints$1.xl, ")"),
  desktopL: "(min-width: ".concat(breakpoints$1.xxl, ")")
};
var theme$1 = {
  breakpoints: breakpoints$1,
  colors: colors$1,
  devices: devices$1,
  fontFamily: fontFamily$1,
  fontFamilyHeading: fontFamilyHeading$1,
  fontSizes: fontSizes$1,
  borderRadius: '3px',
  sectionGutter: '1.5em',
  containerGutter: '1.5rem',
  headingsLineHeight: '1.2',
  headingsMarginTop: '1.5rem',
  headingsMarginBottom: '0',
  fontSizeH1: '2rem',
  fontSizeH2: '1.66rem',
  fontSizeH1Sm: '1.6rem',
  fontSizeH2Sm: '1.4rem',
  fontSizeH3Sm: '1.2rem',
  fontSizeH4Sm: '1.1rem',
  tableHeadFontWeight: 'normal',
  tableHeadCase: 'none',
  tableWidth: '100%',
  accordionSpacing: '10px',
  accordionBackgroundColour: '#8C9BAD',
  accordionTextColour: '#FFF',
  successStatusColour: '#05CD3D',
  warningStatusColour: '#F9C35B',
  errorStatusColour: '#FB4040',
  dialogHeaderBackgroundColour: '#5e5e5e',
  dialogHeaderHighlightColour: '#909090',
  dialogConfirmColour: '#03ba58',
  popoutMenuButtonColour: '#F4F6F9',
  popoutMenuHoverButtonColour: '#383838'
};

var fontFamily = 'Gotham Rounded A, Gotham Rounded B, sans-serif';
var fontFamilyHeading = 'Gotham Rounded A, Gotham Rounded B, sans-serif';
var fontSizes = {
  base: '16px'
};
var colors = {
  textPrimary: '#000',
  primary: '#4d13af',
  primaryDark: '#111',
  tertiary: '#3A8AE8',
  secondary: 'grey',
  active: '#3A8AE8',
  backgroundDark: '#222',
  background: '#F4F6F9',
  linkColor: '#4d13af',
  danger: '#b30000'
};
var breakpoints = {
  xs: '320px',
  sm: '425px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1400px'
};
var devices = {
  mobile: "(min-width: ".concat(breakpoints.xs, ")"),
  mobileL: "(min-width: ".concat(breakpoints.sm, ")"),
  tablet: "(min-width: ".concat(breakpoints.md, ")"),
  laptop: "(min-width: ".concat(breakpoints.lg, ")"),
  desktop: "(min-width: ".concat(breakpoints.xl, ")"),
  desktopL: "(min-width: ".concat(breakpoints.xxl, ")")
};

var theme = _objectSpread2(_objectSpread2({}, polished.fontFace({
  fontFamily: 'Sans-Pro',
  fontFilePath: 'path/to/file'
})), {}, {
  breakpoints: breakpoints,
  colors: colors,
  devices: devices,
  fontFamily: fontFamily,
  fontFamilyHeading: fontFamilyHeading,
  fontSizes: fontSizes,
  borderRadius: '0px',
  sectionGutter: '15px'
});

exports.Accordion = Accordion;
exports.AiTheme = theme;
exports.Alert = Alert;
exports.AnimatedSidebar = AnimatedSidebar;
exports.Article = Article;
exports.Avatar = Avatar;
exports.AvatarIconWithStatusContent = AvatarIconWithStatusContent;
exports.AvatarIconWithStatusWrapper = AvatarIconWithStatusWrapper;
exports.Badge = Badge;
exports.Box = Box;
exports.Button = Button;
exports.ButtonGroup = ButtonGroup;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.Col = Col;
exports.Collapse = Collapse;
exports.Container = Container;
exports.Content = Content;
exports.Dialog = Dialog;
exports.Dropdown = Dropdown;
exports.ErrorStatus = ErrorStatus;
exports.Footer = Footer;
exports.Header = Header;
exports.Input = Input;
exports.InputGroup = InputGroup;
exports.InputLabel = InputLabel;
exports.IxTheme = theme$2;
exports.Link = Link;
exports.List = List;
exports.LoadingProgressBar = LoadingProgressBar;
exports.Logo = Logo;
exports.Menu = Menu;
exports.MenuItem = MenuItem;
exports.Page = Page;
exports.Pagination = Pagination;
exports.Paragraph = Paragraph;
exports.Placeholder = Placeholder;
exports.PopoutMenu = PopoutMenu;
exports.ProgressBar = ProgressBar;
exports.QuickAccessToolbar = QuickAccessToolbar;
exports.RadioButton = RadioButton;
exports.Row = Row;
exports.Section = Section;
exports.Sidebar = Sidebar;
exports.Skeleton = Skeleton;
exports.Spinner = BaseSpinner;
exports.SpudTheme = theme$1;
exports.StyleProvider = StyleProvider;
exports.SuccessStatus = SuccessStatus;
exports.Table = Table;
exports.Text = Text;
exports.Textarea = Textarea;
exports.Title = Title;
exports.Toggle = Toggle;
exports.WarningStatus = WarningStatus;
exports.Wrapper = Wrapper;
